<template>
  <div :class="$style.page">
    <!-- Hero -->
    <section :class="$style.hero">
      <div :class="$style.heroInner">
        <img :class="$style.heroLogo" src="@/assets/images/linkooklive_longlogo.png" alt="링꾹라이브 로고" />
        <p :class="$style.heroTag">서브컬처 라이브공연 · 아티스트 플랫폼</p>
        <h1 :class="$style.heroTitle">
          서브컬처 라이브 공연,<br />
          링꾹라이브가 함께합니다.
        </h1>
        <p :class="$style.heroDesc">
          링꾹라이브는 흩어진 서브컬처 라이브 공연 정보를 한 곳에 모으고,<br />
          공연을 만드는 분들의 운영을 <br />IT 기술로 단단하게 받쳐드려요.
        </p>
        <div :class="$style.heroCtas">
          <button :class="[$style.cta, $style.ctaPrimary]" @click="goTo('/')">
            지금 공연 보러가기
          </button>
          <button :class="[$style.cta, $style.ctaGhost]" @click="openKakao">
            공연 지원 문의하기
          </button>
        </div>
      </div>
      <div :class="$style.heroDecor" aria-hidden="true"></div>
    </section>

    <!-- 우리는 누구 -->
    <section :class="$style.section" id="about-linkook">
      <p :class="$style.eyebrow">ABOUT LINKOOK LIVE</p>
      <h2 :class="$style.sectionTitle">링꾹라이브는요</h2>
      <p :class="[$style.sectionLead, $style.aboutIntroLead]">
        보컬라이브, 밴드라이브, 댄스라이브까지 <br />
        장르의 경계를 가르지 않는 <b>서브컬처 라이브</b>를 위한 플랫폼이에요.<br />
        <br />
        관객과 아티스트를 이어주고 <br />주최자에게는 <b>공연·예매 통합 관리 시스템</b>을 제공합니다.
      </p>

      <!-- 플랫폼 홈 목업 (실제 링꾹라이브 홈 화면을 단순화) -->
      <div :class="$style.aboutPlatformMock" aria-hidden="true">
        <!-- 브라우저 툴바 -->
        <div :class="$style.aboutMockToolbar">
          <div :class="$style.aboutMockDots">
            <span></span><span></span><span></span>
          </div>
          <div :class="$style.aboutMockUrlBar">
            <span :class="$style.aboutMockUrl">linkook.live</span>
          </div>
          <span :class="$style.aboutMockToolbarSpacer"></span>
        </div>

        <div :class="$style.aboutMockBody">
          <!-- 로고 + 로그인 -->
          <!-- <div :class="$style.aboutMockHeader">
            <span :class="$style.aboutMockLogoText">LINKOOK LIVE</span>
            <span :class="$style.aboutMockLoginBtn">로그인</span>
          </div> -->

          <!-- 네비 -->
          <!-- <div :class="$style.aboutMockNav">
            <span :class="[$style.aboutMockNavItem, $style.aboutMockNavActive]">라이브</span>
            <span :class="$style.aboutMockNavItem">아티스트</span>
            <span :class="$style.aboutMockNavItem">동영상</span>
            <span :class="$style.aboutMockNavItem">커뮤니티</span>
          </div> -->

          <!-- 전광판 마키 — 레퍼런스 공연과 동일 데이터 -->
          <!-- <div :class="$style.aboutMockMarquee">
            <div v-if="referencesLoading" :class="[$style.aboutMockMarqueeTrack, $style.aboutMockMarqueePaused]">
              <span>🎵 레퍼런스 공연을 불러오는 중…</span>
              <span>🎵 레퍼런스 공연을 불러오는 중…</span>
            </div>
            <div v-else-if="aboutMockReferencesForHome.length" :class="$style.aboutMockMarqueeTrack">
              <template v-for="dup in 2" :key="'mq-dup-' + dup">
                <span v-for="live in aboutMockReferencesForHome" :key="'mq-' + dup + '-' + live.id">{{ aboutMockMarqueeLine(live)
                  }}</span>
              </template>
</div>
<div v-else :class="[$style.aboutMockMarqueeTrack, $style.aboutMockMarqueePaused]">
  <span>🎵 아래 "함께한 공연들" 섹션에서 링꾹 레퍼런스를 확인할 수 있어요</span>
</div>
</div> -->

          <!-- 타입 필터 -->
          <div :class="$style.aboutMockTypeFilter">
            <span :class="$style.aboutMockHeartBtn">♡</span>
            <span :class="[$style.aboutMockTypeBtn, $style.aboutMockTypeActive]">전체</span>
            <span :class="$style.aboutMockTypeBtn">보컬</span>
            <span :class="$style.aboutMockTypeBtn">밴드</span>
            <span :class="$style.aboutMockTypeBtn">댄스</span>
            <span :class="$style.aboutMockTypeBtn">그 외</span>
          </div>

          <!-- 검색 + 정렬 -->
          <div :class="$style.aboutMockSearchRow">
            <div :class="$style.aboutMockSearch">
              <span :class="$style.aboutMockSearchPh">제목, 라인업, 장소 검색</span>
            </div>
            <span :class="$style.aboutMockSortBtn">최신순 <span :class="$style.aboutMockSortArrow">⇅</span></span>
          </div>

          <!-- 타일 그리드 — 레퍼런스 상위 3개 -->
          <div :class="$style.aboutMockTiles">
            <template v-if="referencesLoading">
              <div v-for="n in 3" :key="'about-sk-' + n" :class="$style.aboutMockTile">
                <div :class="[$style.aboutMockPoster, $style.aboutMockPosterSkeleton]"></div>
                <div :class="[$style.aboutMockSkeletonLine, $style.aboutMockSkeletonDate]"></div>
                <div :class="[$style.aboutMockSkeletonLine, $style.aboutMockSkeletonTitle]"></div>
                <div :class="$style.aboutMockSkeletonLineup">
                  <span :class="$style.aboutMockSkeletonPill"></span>
                  <span :class="$style.aboutMockSkeletonPill"></span>
                </div>
              </div>
            </template>
            <template v-else-if="aboutMockTileLives.length">
              <div v-for="(live, idx) in aboutMockTileLives" :key="'about-tile-' + live.id"
                :class="$style.aboutMockTile">
                <div :class="$style.aboutMockPoster">
                  <img v-if="live.imgUrl" :src="live.imgUrl" alt="" :class="$style.aboutMockPosterImg" />
                  <svg v-else viewBox="0 0 100 140" preserveAspectRatio="none" :class="$style.aboutMockPosterArt">
                    <defs>
                      <linearGradient :id="'aboutGradMock-' + live.id" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0%" :stop-color="aboutMockGradStops(idx).from" />
                        <stop offset="100%" :stop-color="aboutMockGradStops(idx).to" />
                      </linearGradient>
                    </defs>
                    <rect width="100" height="140" :fill="'url(#aboutGradMock-' + live.id + ')'" />
                    <circle cx="76" cy="36" r="22" fill="rgba(255,255,255,0.28)" />
                    <path d="M0 110 L28 92 L52 102 L76 84 L100 96 L100 140 L0 140Z" fill="rgba(15,23,42,0.18)" />
                  </svg>
                  <span v-if="aboutMockShowLinkookLabel(live)" :class="$style.aboutMockLinkookLabel">링꾹예매중</span>
                  <span v-if="aboutMockCalculateDaysLeft(live)" :class="aboutMockDdayPillClass(live)">{{
                    aboutMockCalculateDaysLeft(live) }}</span>
                  <img v-if="aboutMockTypeImg(live.type)" :src="aboutMockTypeImg(live.type)" alt=""
                    :class="$style.aboutMockTypeIconImg" />
                  <span v-else :class="$style.aboutMockTypeIconFallback">🎵</span>
                  <span :class="$style.aboutMockHeart">♡</span>
                </div>
                <div :class="$style.aboutMockTileDate">{{ formatRefDate(live.date) || "날짜 미정" }}</div>
                <div :class="$style.aboutMockTileTitle">{{ live.title || "제목 없음" }}</div>
                <!-- <div :class="$style.aboutMockLineup">
                  <template v-if="live.lineup && live.lineup.length">
                    <span v-for="(name, pi) in live.lineup.slice(0, 4)" :key="pi" :class="$style.aboutMockLineupPill">{{
                      name }}</span>
                  </template>
  <span v-else :class="[$style.aboutMockLineupPill, $style.aboutMockLineupMuted]">라인업</span>
</div> -->
              </div>
            </template>
            <div v-else :class="$style.aboutMockTilesEmpty">
              <p v-if="references.length === 1" :class="$style.aboutMockTilesEmptyText">
                레퍼런스가 한 건뿐이면 홈 목업에는 표시하지 않아요. "함께한 공연들" 섹션에서 해당 공연을 볼 수 있어요.
              </p>
              <p v-else :class="$style.aboutMockTilesEmptyText">
                레퍼런스로 지정된 공연이 없어요. "함께한 공연들"과 같은 목록이 채워지면 이 미리보기에도 자동으로 표시됩니다.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- 하단 키 포인트 -->
      <!-- <div :class="$style.aboutKeyPoints">
        <div :class="$style.aboutKeyPoint">
          <span :class="$style.aboutKeyPointEmoji">🎟️</span>
          <span :class="$style.aboutKeyPointText"><b>관객</b>은 탐색부터 QR 입장까지</span>
        </div>
        <div :class="$style.aboutKeyPoint">
          <span :class="$style.aboutKeyPointEmoji">🎤</span>
          <span :class="$style.aboutKeyPointText"><b>아티스트</b>는 팬과 직접 만나는 채널</span>
        </div>
        <div :class="$style.aboutKeyPoint">
          <span :class="$style.aboutKeyPointEmoji">📋</span>
          <span :class="$style.aboutKeyPointText"><b>주최자</b>는 운영 부담 없이 공연 진행</span>
        </div>
      </div> -->
    </section>

    <!-- 누구를 위한 서비스인지 -->
    <!-- <section :class="$style.section">
      <p :class="$style.eyebrow">WHO IT'S FOR</p>
      <h2 :class="$style.sectionTitle">관객과 아티스트를 위한 서비스예요</h2>
      <p :class="$style.sectionLead">
        링꾹라이브는 <b>관객</b>과 <b>공연 주최자/아티스트</b>가 만나는 공간이에요.<br />
        <br />
        아래에서 원하는 영역의 자세한 기능을 확인해보세요.
      </p>

      <div :class="$style.dualNav">
        <a :class="$style.dualNavItem" href="/" @click.prevent="goTo('/')">
          <span :class="$style.dualNavLabel">FOR AUDIENCE</span>
          <span :class="$style.dualNavTitle">관객을 위한 기능</span>
          <span :class="$style.dualNavSub">공연 탐색·예매·QR 입장·커뮤니티</span>
        </a>
        <a :class="$style.dualNavItem" href="#for-organizer" @click.prevent="scrollTo('for-organizer')">
          <span :class="$style.dualNavLabel">FOR ORGANIZER</span>
          <span :class="$style.dualNavTitle">주최자·아티스트 솔루션</span>
          <span :class="$style.dualNavSub">공연관리·예매관리·홍보·현장 운영</span>
        </a>
      </div>
    </section> -->

    <!-- 주최자 / 아티스트 솔루션 -->
    <section :class="$style.organizerSection" id="for-organizer">
      <div :class="$style.section">
        <p :class="$style.eyebrow">FOR ORGANIZER</p>
        <h2 :class="$style.sectionTitle">라이브 주최를 위한 지원 서비스</h2>
        <p :class="$style.sectionLeadShort">
          홍보부터 예매·정산·현장 운영까지, 링꾹이 도와드려요.
        </p>

        <!-- 핵심 3대 영역 - 칩 기반 압축 카드 -->
        <div :class="$style.pillarGrid">
          <div :class="$style.pillarCard">
            <div :class="$style.pillarTag">MARKETING</div>
            <h3 :class="$style.pillarTitle">SNS 홍보 지원</h3>
            <p :class="$style.pillarLine">
              링꾹 공식 채널로 수요자에게 정확히 도달
            </p>
            <div :class="$style.pillarChips">
              <span :class="$style.pillarChip">트위터</span>
              <span :class="$style.pillarChip">인스타그램</span>
              <span :class="$style.pillarChip">타겟 노출</span>
            </div>
          </div>

          <div :class="$style.pillarCard">
            <div :class="$style.pillarTag">DATA</div>
            <h3 :class="$style.pillarTitle">예매·정산 관리</h3>
            <p :class="$style.pillarLine">
              실시간 트래킹과 자동 정산으로 편리한 예매관리
            </p>
            <div :class="$style.pillarChips">
              <span :class="$style.pillarChip">실시간 대시보드</span>
              <span :class="$style.pillarChip">자동 정산</span>
            </div>
          </div>

          <div :class="$style.pillarCard">
            <div :class="$style.pillarTag">STAFF</div>
            <h3 :class="$style.pillarTitle">현장 스태프 지원</h3>
            <p :class="$style.pillarLine">
              현장 입장 관리 및 굿즈판매 인력 지원
            </p>
            <div :class="$style.pillarChips">
              <span :class="$style.pillarChip">QR 입장</span>
              <span :class="$style.pillarChip">동선 관리</span>
              <span :class="$style.pillarChip">최대 4명</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 예매 폼 빌더 (TicketForm) -->
    <section :class="$style.section" id="booking-form">
      <p :class="$style.eyebrowAlt">BOOKING FORM</p>
      <h2 :class="$style.sectionTitle">맞춤형 예매 폼 빌더</h2>
      <p :class="$style.sectionLeadShort">
        공연마다 다른 안내·질문·옵션도 자유롭게. <br />
        후원 패키지와 굿즈까지 한 폼에서 관리할 수 있어요.
      </p>

      <div :class="$style.formBuilderSplit">
        <!-- 핵심 기능 4가지 -->
        <ul :class="$style.featureRows">
          <li :class="$style.featureRow">
            <span :class="$style.featureRowNum">01</span>
            <div>
              <h4 :class="$style.featureRowTitle">커스텀 질문 생성</h4>
              <p :class="$style.featureRowDesc">
                단답형·장문형·객관식·체크박스 네 가지 타입, 이미지 첨부와 필수 여부도 지정 가능해요.
              </p>
            </div>
          </li>
          <li :class="$style.featureRow">
            <span :class="$style.featureRowNum">02</span>
            <div>
              <h4 :class="$style.featureRowTitle">후원 티켓 패키지</h4>
              <p :class="$style.featureRowDesc">
                티어별 가격·구성품·이미지 등록, 최대 수량 제한과 수량별 합계도 표시됩니다.
              </p>
            </div>
          </li>
          <li :class="$style.featureRow">
            <span :class="$style.featureRowNum">03</span>
            <div>
              <h4 :class="$style.featureRowTitle">추가구매(굿즈) 옵션</h4>
              <p :class="$style.featureRowDesc">
                상품별 가격·필수 여부·옵션(사이즈·색상 등)까지, 텍스트·라디오·체크박스로 자유롭게 설정할 수 있어요.
              </p>
            </div>
          </li>
          <li :class="$style.featureRow">
            <span :class="$style.featureRowNum">04</span>
            <div>
              <h4 :class="$style.featureRowTitle">오픈 카운트다운</h4>
              <p :class="$style.featureRowDesc">
                예매 시작 전까지 공연 상세와 예매 폼에 남은 시간이 실시간으로 표시되고, 오픈·마감 시각에 맞춰 접수가 자동으로 열리고 닫혀요.
              </p>
            </div>
          </li>
        </ul>

        <!-- 폼 빌더 목업 -->
        <div ref="formBuilderMockStage" :class="$style.formBuilderMockStage">
          <div :class="$style.formMock" aria-hidden="true">
            <div :class="$style.mockToolbar">
              <div :class="$style.mockDots">
                <span></span><span></span><span></span>
              </div>
              <div :class="$style.mockTitle">커스텀 예매 폼</div>
            </div>

            <div :class="$style.formMockBody">
              <!-- 후원 패키지 -->
              <div :class="$style.formMockSection">
                <div :class="$style.formMockHead">
                  <span :class="$style.formMockHeadTitle">후원 티켓 패키지</span>
                </div>
                <div :class="[
                  $style.formMockPackage,
                  $style.formMockPackageClickable,
                  formMockPackageTier === 'special' ? $style.formMockPackageSelected : null,
                ]" @click="setFormMockPackageTier('special')">
                  <div :class="$style.formMockPackageRow">
                    <span v-if="formMockPackageTier === 'special'" :class="$style.formMockPackageCheck">✓</span>
                    <span v-else :class="$style.formMockPackageCheckSpacer" />
                    <span :class="$style.formMockPackageName">SPECIAL</span>
                    <span :class="$style.formMockPackagePrice">80,000원</span>
                  </div>
                  <div :class="$style.formMockPackageDesc">티켓 + 포토카드 + 사인 포스터</div>
                </div>
                <div ref="formMockBasicPackageEl" :class="[
                  $style.formMockPackage,
                  $style.formMockPackageClickable,
                  formMockPackageTier === 'basic' ? $style.formMockPackageSelected : null,
                  formMockBasicDemoPress ? $style.formMockPackageDemoPress : null,
                ]" @click="setFormMockPackageTier('basic')">
                  <div :class="$style.formMockPackageRow">
                    <span v-if="formMockPackageTier === 'basic'" :class="$style.formMockPackageCheck">✓</span>
                    <span v-else :class="$style.formMockPackageCheckSpacer" />
                    <span :class="$style.formMockPackageName">BASIC</span>
                    <span :class="$style.formMockPackagePrice">30,000원</span>
                  </div>
                </div>
              </div>

              <!-- 커스텀 질문 -->
              <div :class="$style.formMockSection">
                <div :class="$style.formMockHead">
                  <span :class="$style.formMockHeadTitle">응원하시는 아티스트는?</span>
                  <span :class="$style.formMockBadge">필수</span>
                </div>
                <div :class="$style.formMockRadioGroup">
                  <span :class="$style.formMockRadio">A 팀</span>
                  <span :class="[$style.formMockRadio, $style.formMockRadioActive]">B 팀</span>
                  <span :class="$style.formMockRadio">둘 다</span>
                </div>
              </div>

              <!-- 추가구매 -->
              <div :class="$style.formMockSection">
                <div :class="$style.formMockHead">
                  <span :class="$style.formMockHeadTitle">추가구매항목</span>
                </div>
                <div :class="$style.formMockAddonList">
                  <div :class="$style.formMockPurchase">
                    <div :class="$style.formMockPurchaseRow">
                      <span :class="$style.formMockPurchaseName">응원봉 세트</span>
                      <span :class="$style.formMockPurchasePrice">12,000원</span>
                    </div>
                    <div :class="$style.formMockQtyRow">
                      <span :class="$style.formMockQtyBtn">−</span>
                      <span :class="$style.formMockQtyValue">{{ formMockCheerStickQty }}</span>
                      <button type="button" ref="formMockCheerPlusBtn" :class="[
                        $style.formMockQtyBtn,
                        formMockCheerPlusDemoPress ? $style.formMockQtyBtnDemoPress : null,
                      ]" tabindex="-1" @click="incrementFormMockCheerStick">
                        +
                      </button>
                      <span :class="$style.formMockQtySubtotal">{{ formMockCheerLineSubtotal }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 최종 금액 -->
              <div :class="$style.formMockTotal">
                <div :class="$style.formMockTotalLabel">최종 입금 금액</div>
                <div :key="formMockTotalAmount" :class="[
                  $style.formMockTotalValue,
                  formMockTotalBump ? $style.formMockTotalBumpAnim : null,
                ]">
                  {{ formMockTotalFormatted }}
                </div>
                <div :class="$style.formMockTotalCalc">{{ formMockCalcSummary }}</div>
              </div>
            </div>
          </div>

          <div v-show="formBuilderDemoCursorVisible" :class="[
            $style.formBuilderDemoCursor,
            formBuilderDemoCursorMoving ? $style.formBuilderDemoCursorMove : null,
            formBuilderDemoCursorPressing ? $style.formBuilderDemoCursorPress : null,
          ]" :style="{ transform: formBuilderDemoCursorTransform }" aria-hidden="true">
            <svg :class="$style.formBuilderDemoCursorSvg" xmlns="http://www.w3.org/2000/svg" width="32" height="32"
              viewBox="0 0 32 32" aria-hidden="true">
              <path :class="$style.formBuilderDemoCursorPath"
                d="M4 2 L4 22 L9.5 16.5 L12.5 25 L15.5 23.5 L12 15.5 L21 15.5 Z" />
            </svg>
          </div>
        </div>
      </div>
    </section>


    <!-- 예매관리 시스템 (시각적 분리) -->
    <section :class="$style.section" id="reservation-management">
      <p :class="$style.eyebrowAlt">RESERVATION MANAGEMENT</p>
      <h2 :class="$style.sectionTitle">예매관리 시스템</h2>
      <p :class="$style.sectionLeadShort">
        예매 접수부터 입금 확인, 알림 발송, 정산까지. 한 화면에서 끝나는 통합 관리 시스템.
      </p>

      <div :class="$style.dashboardSplit">
        <!-- 미니 대시보드 목업 -->
        <div :class="$style.dashboardMock" aria-hidden="true">
          <div :class="$style.mockToolbar">
            <div :class="$style.mockDots">
              <span></span><span></span><span></span>
            </div>
            <div :class="$style.mockTitle">예매 관리 · 라이브 공연</div>
          </div>

          <div :class="$style.mockTabs">
            <span :class="[$style.mockTab, $style.mockTabActive]">전체 124</span>
            <span :class="$style.mockTab">대기 18</span>
            <span :class="$style.mockTab">확정 96</span>
            <span :class="$style.mockTab">환불 4</span>
            <span :class="$style.mockTab">취소 6</span>
          </div>

          <div :class="$style.mockSearch">
            <span :class="$style.mockSearchIcon">🔍</span>
            <span :class="$style.mockSearchText">이름·이메일 검색</span>
          </div>

          <div :class="$style.mockTable">
            <div :class="[
              $style.mockRow,
              reservationDemoPulseRow === 0 ? $style.mockRowDemoPulse : null,
            ]">
              <span :class="$style.mockTid">#O2L8NSL0</span>
              <span :class="$style.mockName">김○○</span>
              <span :class="$style.mockTime">10:24:31</span>
              <span :class="[$style.mockStatus, reservationDemoStatusClass(0)]">
                {{ reservationDemoStatusText(0) }}
              </span>
            </div>
            <div :class="[
              $style.mockRow,
              reservationDemoPhase < 2 ? $style.mockRowHighlight : null,
              reservationDemoPulseRow === 1 ? $style.mockRowDemoPulse : null,
            ]">
              <span :class="$style.mockTid">#K9M3PLQ1</span>
              <span :class="$style.mockName">박○○</span>
              <span :class="$style.mockTime">10:24:48</span>
              <span :class="$style.mockExtra">초대</span>
              <span :class="[$style.mockStatus, reservationDemoStatusClass(1)]">
                {{ reservationDemoStatusText(1) }}
              </span>
            </div>
            <div :class="[
              $style.mockRow,
              reservationDemoPulseRow === 2 ? $style.mockRowDemoPulse : null,
            ]">
              <span :class="$style.mockTid">#R4N8XW2Z</span>
              <span :class="$style.mockName">이○○</span>
              <span :class="$style.mockTime">10:25:12</span>
              <span :class="$style.mockExtra">+굿즈</span>
              <span :class="[$style.mockStatus, reservationDemoStatusClass(2)]">
                {{ reservationDemoStatusText(2) }}
              </span>
            </div>
            <div :class="$style.mockRow">
              <span :class="$style.mockTid">#P7Q2VK9M</span>
              <span :class="$style.mockName">정○○</span>
              <span :class="$style.mockTime">10:25:39</span>
              <span :class="[$style.mockStatus, reservationDemoStatusClass(3)]">
                {{ reservationDemoStatusText(3) }}
              </span>
            </div>
          </div>


          <!-- 집계 카드 -->
          <div :class="$style.mockSummary">
            <div :class="$style.mockSummaryRow">
              <span :class="$style.mockSummaryLabel">총 예매 금액</span>
              <span :class="$style.mockSummaryValue">2,480,000원</span>
            </div>
            <div :class="$style.mockSummaryRowSub">
              <span :class="$style.mockSummaryLabelSub">패키지 · 추가구매 합계</span>
              <span :class="$style.mockSummaryValueSub">+ 530,000원</span>
            </div>
          </div>

          <!-- 액션 칩 -->
          <div :class="$style.mockActions">
            <span :class="$style.mockActionChip">📣 공지 알림</span>
            <span :class="$style.mockActionChip">⬇ CSV</span>
            <span :class="$style.mockActionChip">🎟️ 초대권</span>
          </div>
        </div>

        <!-- 핵심 기능 4가지 -->
        <ul :class="$style.featureRows">
          <li :class="$style.featureRow">
            <span :class="$style.featureRowNum">01</span>
            <div>
              <h4 :class="$style.featureRowTitle">실시간 현황 관리</h4>
              <p :class="$style.featureRowDesc">
                상태별 필터(대기·확정·취소·환불), 이름·이메일 검색, 정렬을 한 화면에서 처리할 수 있어요.
              </p>
            </div>
          </li>
          <li :class="$style.featureRow">
            <span :class="$style.featureRowNum">02</span>
            <div>
              <h4 :class="$style.featureRowTitle">초대권 발급</h4>
              <p :class="$style.featureRowDesc">
                링꾹 회원을 닉네임·이메일로 검색해 초대권을 발급, QR티켓도 즉시 자동 생성해요.
              </p>
            </div>
          </li>
          <li :class="$style.featureRow">
            <span :class="$style.featureRowNum">03</span>
            <div>
              <h4 :class="$style.featureRowTitle">정산·내보내기</h4>
              <p :class="$style.featureRowDesc">
                티켓·패키지·추가구매를 자동 집계해 정산표 생성, CSV 한 번 클릭으로 다운로드할 수 있어요.
              </p>
            </div>
          </li>
          <li :class="$style.featureRow">
            <span :class="$style.featureRowNum">04</span>
            <div>
              <h4 :class="$style.featureRowTitle">확정·취소·환불 처리</h4>
              <p :class="$style.featureRowDesc">
                확정·취소·환불 처리를 한 화면에서 손쉽게 처리할 수 있어요.
              </p>
            </div>
          </li>
        </ul>
      </div>
    </section>

    <!-- 카카오 알림톡 · QR 티켓 페이지 -->
    <section :class="$style.section" id="alimtalk-qr">
      <p :class="$style.eyebrowAlt">ALIMTALK & QR PAGE</p>
      <h2 :class="$style.sectionTitle">카카오 알림톡과 QR 티켓 페이지</h2>
      <p :class="$style.sectionLeadShort">
        확정·추가 안내·공연 당일 입장까지, 관객에게 필요한 순간에 카카오 알림톡이 발송됩니다. <br />
        메시지에 포함된 링크를 누르면 앱 설치 없이 QR 티켓 페이지가 열려요.
      </p>

      <div :class="[$style.dashboardSplit, $style.dashboardSplitMockRight]">
        <div ref="alimtalkQrStage" :class="[$style.alimtalkQrStage, isQrViewActive ? $style.stageQrActive : null]">

          <!-- 카카오 알림톡 메시지 목업 -->
          <div :class="[$style.kakaoMock, $style.stageScreen]">
            <div :class="$style.kakaoMockThread">
              <div :class="$style.kakaoMockHead">
                <span :class="$style.kakaoMockSender">링꾹</span>
                <span :class="$style.kakaoMockKakaoBadge">kakao</span>
              </div>
              <div :class="$style.kakaoMockBubble">
                <div :class="$style.kakaoMockBubbleHead">알림톡 도착</div>
                <div :class="$style.kakaoMockBubbleBody">
                  <p>
                    블랙슈님께서 예매하신 <b>Sound Station 5.9</b>이 합정 사운드스테이션에서
                    <b>2026.05.09 18:00</b>에 시작됩니다.
                  </p>
                  <p>
                    ▶입장절차<br />
                    1. 합정 사운드스테이션 방문<br />
                    2. 입장시 하단의 QR코드 링크 접속<br />
                    3. QR코드 스캔 후 입장
                  </p>
                  <p>
                    원활한 공연 진행을 위해 공연이 시작하기 전에 입장해주세요.<br />
                    * 초대권도 같은 방식으로 입장됩니다.
                  </p>
                </div>
                <div :class="$style.kakaoMockBubbleActions">
                  <button ref="alimtalkQrLinkBtn" type="button" :class="[
                    $style.kakaoMockBubbleBtn,
                    alimtalkDemoBtnPressing ? $style.kakaoMockBubbleBtnDemoPress : null,
                  ]" @click="showQrView">
                    QR코드 링크
                  </button>
                  <span :class="$style.kakaoMockBubbleBtn">공연 상세 정보</span>
                </div>
              </div>
              <div :class="$style.kakaoMockTime">오후 1:51</div>
            </div>
          </div>

          <!-- QR 입장 페이지 목업 -->
          <div :class="[$style.dashboardMock, $style.stageScreen, $style.stageScreenQr]">
            <div :class="$style.mockToolbar">
              <div :class="$style.mockDots">
                <span></span><span></span><span></span>
              </div>
              <div :class="$style.mockTitle">QR 입장 티켓</div>
              <button ref="alimtalkQrBackBtn" type="button" :class="[
                $style.mockBackBtn,
                alimtalkDemoBackBtnPressing ? $style.mockBackBtnDemoPress : null,
              ]" @click="showAlimtalkView" aria-label="알림톡 다시 보기">
                ← 알림톡
              </button>
            </div>
            <div :class="$style.qrDemoCardBody">
              <div :class="$style.qrMockCard">
                <div :class="$style.qrMockHeader">
                  <span :class="$style.qrMockBrand">LINKOOK LIVE</span>
                  <span :class="$style.qrMockBadge">QR 입장 티켓</span>
                </div>
                <h3 :class="$style.qrMockTitle">Sound Station 5.9</h3>
                <p :class="$style.qrMockSubtitle">
                  <span>2026.05.09 (토) 18:00</span>
                  <span :class="$style.qrMockDot">·</span>
                  <span>사운드스테이션</span>
                </p>
                <div :class="$style.qrMockImageWrap">
                  <img v-if="aboutQrDemoUrl" :src="aboutQrDemoUrl" alt="" :class="$style.qrMockImage" />
                  <div v-else :class="$style.qrMockImagePlaceholder">QR 생성 중…</div>
                </div>
                <p :class="$style.qrMockFooterNote">입장 시 운영자에게 위 QR 코드를 보여주세요.</p>
              </div>
            </div>
          </div>

          <!-- 데모용 가상 마우스 커서 (알림톡 → QR 전환 연출) -->
          <div v-show="alimtalkDemoCursorVisible" :class="[
            $style.alimtalkDemoCursor,
            alimtalkDemoCursorMoving ? $style.alimtalkDemoCursorMove : null,
            alimtalkDemoCursorPressing ? $style.alimtalkDemoCursorPress : null,
          ]" :style="{ transform: alimtalkDemoCursorTransform }" aria-hidden="true">
            <svg :class="$style.alimtalkDemoCursorSvg" xmlns="http://www.w3.org/2000/svg" width="32" height="32"
              viewBox="0 0 32 32" aria-hidden="true">
              <path :class="$style.alimtalkDemoCursorPath"
                d="M4 2 L4 22 L9.5 16.5 L12.5 25 L15.5 23.5 L12 15.5 L21 15.5 Z" />
            </svg>
          </div>
        </div>

        <ul :class="$style.featureRows">
          <li :class="$style.featureRow">
            <span :class="$style.featureRowNum">01</span>
            <div>
              <h4 :class="$style.featureRowTitle">확정 시 자동 발송</h4>
              <p :class="$style.featureRowDesc">
                입금이 확인되어 예매가 확정되면, 티켓 번호와 함께 안내 카카오 알림톡이 자동으로 발송됩니다.
              </p>
            </div>
          </li>

          <li :class="$style.featureRow">
            <span :class="$style.featureRowNum">02</span>
            <div>
              <h4 :class="$style.featureRowTitle">안내사항 발생 시 추가 발송</h4>
              <p :class="$style.featureRowDesc">
                공연 일정 변경 등 안내가 필요할 때, 확정 예매자에게 알림톡을 한 번에 보낼 수 있어요.
              </p>
            </div>
          </li>
          <li :class="$style.featureRow">
            <span :class="$style.featureRowNum">03</span>
            <div>
              <h4 :class="$style.featureRowTitle">공연 당일 QR 안내</h4>
              <p :class="$style.featureRowDesc">
                공연 당일 입장용 QR·현장 안내가 담긴 알림톡을 발송할 수 있어요. 링크는 QR티켓 전용 페이지로 연결됩니다.
              </p>
            </div>
          </li>
        </ul>
      </div>
    </section>

    <!-- 권한관리 (멤버 위임 · 협업) -->
    <section :class="$style.section" id="permission">
      <p :class="$style.eyebrowAlt">PERMISSION</p>
      <h2 :class="$style.sectionTitle">함께 운영하는 권한관리</h2>
      <p :class="$style.sectionLeadShort">
        공연 상세 화면의 관리 메뉴에서 신뢰하는 멤버에게 운영 권한을 위임할 수 있어요. <br />
        부여 즉시 수정·삭제·예매관리까지 동일한 권한으로 함께 운영합니다.
      </p>

      <div :class="[$style.dashboardSplit, $style.dashboardSplitMockRight]">
        <div :class="$style.permissionStage">
          <!-- LiveDetail 진입 경로 안내 (공연 상세 → ⚙ → 권한관리) -->
          <div :class="$style.permissionEntryPath" aria-hidden="true">
            <span :class="$style.permissionEntryStep">공연 상세</span>
            <span :class="$style.permissionEntryArrow">›</span>
            <span :class="$style.permissionEntryStep">
              <svg :class="$style.permissionEntryGear" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                aria-hidden="true">
                <circle cx="12" cy="12" r="3" />
                <path
                  d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
              </svg>
              관리 메뉴
            </span>
            <span :class="$style.permissionEntryArrow">›</span>
            <span :class="[$style.permissionEntryStep, $style.permissionEntryStepActive]">권한관리</span>
          </div>

          <!-- 권한관리 모달 목업 -->
          <div :class="$style.permissionMock">
            <div :class="$style.permissionMockHeader">
              <span :class="$style.permissionMockHeaderTitle">권한관리</span>
              <span :class="$style.permissionMockHeaderClose" aria-hidden="true">×</span>
            </div>
            <div :class="$style.permissionMockBody">
              <p :class="$style.permissionMockHint">
                권한을 부여받은 사용자는 이 라이브의 <b>수정 · 삭제 · 예매관리</b> 권한을 갖게 됩니다.
              </p>

              <h4 :class="$style.permissionMockSectionTitle">관리 권한 보유자</h4>
              <div :class="$style.permissionMockMemberList">
                <div :class="$style.permissionMockMember">
                  <div :class="[$style.permissionMockAvatar, $style.permissionMockAvatarPurple]">L</div>
                  <div :class="$style.permissionMockMemberInfo">
                    <span :class="$style.permissionMockMemberName">링꾹지기</span>
                    <span :class="$style.permissionMockMemberEmail">linkook@linkook.com</span>
                  </div>
                  <span :class="$style.permissionMockOwnerBadge">주최자</span>
                </div>
                <div :class="$style.permissionMockMember">
                  <div :class="[$style.permissionMockAvatar, $style.permissionMockAvatarPink]">B</div>
                  <div :class="$style.permissionMockMemberInfo">
                    <span :class="$style.permissionMockMemberName">블랙슈</span>
                    <span :class="$style.permissionMockMemberEmail">blackshu@linkook.com</span>
                  </div>
                  <span :class="$style.permissionMockRemoveBtn">삭제</span>
                </div>
              </div>

              <h4 :class="$style.permissionMockSectionTitle">권한 부여</h4>
              <div :class="$style.permissionMockSearchRow">
                <div :class="$style.permissionMockSearch">
                  <span :class="$style.permissionMockSearchIcon" aria-hidden="true">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                      <circle cx="11" cy="11" r="7" />
                      <line x1="21" y1="21" x2="16.65" y2="16.65" />
                    </svg>
                  </span>
                  <span :class="$style.permissionMockSearchText">닉네임 또는 이메일로 검색</span>
                </div>
                <span :class="$style.permissionMockAddBtn">추가</span>
              </div>
            </div>
          </div>
        </div>

        <ul :class="$style.featureRows">
          <li :class="$style.featureRow">
            <span :class="$style.featureRowNum">01</span>
            <div>
              <h4 :class="$style.featureRowTitle">신뢰하는 멤버에게 위임</h4>
              <p :class="$style.featureRowDesc">
                닉네임·이메일로 사용자를 검색해, 함께 일하는 매니저나 스태프에게 운영 권한을 부여할 수 있어요.
              </p>
            </div>
          </li>

          <li :class="$style.featureRow">
            <span :class="$style.featureRowNum">02</span>
            <div>
              <h4 :class="$style.featureRowTitle">수정 · 삭제 · 예매관리까지</h4>
              <p :class="$style.featureRowDesc">
                권한을 부여받은 멤버는 공연 정보 수정, 예매폼·예매 관리까지 주최자와 동일한 권한으로 운영에 참여합니다.
              </p>
            </div>
          </li>

          <li :class="$style.featureRow">
            <span :class="$style.featureRowNum">03</span>
            <div>
              <h4 :class="$style.featureRowTitle">언제든 안전하게 회수</h4>
              <p :class="$style.featureRowDesc">
                누구에게 권한이 부여되어 있는지 한눈에 보고, 멤버 목록에서 클릭 한 번으로 즉시 권한을 회수할 수 있어요.
              </p>
            </div>
          </li>
        </ul>
      </div>
    </section>

    <!-- 편리한 QR 입장 확인 (CheckInView) -->
    <section :class="$style.section" id="checkin">
      <p :class="$style.eyebrowAlt">CHECK-IN</p>
      <h2 :class="$style.sectionTitle">편리한 QR 입장 확인</h2>
      <p :class="$style.sectionLeadShort">
        예매자에게 발송된 입장 QR을 스캔하면 예약 정보가 즉시 표시돼요. <br />
        현장에서 빠르고 안전하게 입장을 처리하고, 실시간 입장 현황까지 한눈에 확인할 수 있어요.
      </p>

      <div :class="$style.dashboardSplit">
        <!-- 모바일 폰 형태의 CheckInView 목업 -->
        <div :class="$style.checkinStage">
          <div :class="$style.checkinPhone" aria-hidden="true">
            <!-- 폰 상단 노치 -->
            <div :class="$style.checkinPhoneNotch"></div>

            <!-- 입장 확인 화면 헤더 -->
            <div :class="$style.checkinMockHeader">
              <span :class="$style.checkinMockBack">←</span>
              <div :class="$style.checkinMockHeaderCenter">
                <span :class="$style.checkinMockHeaderTitle">입장 확인</span>
                <span :class="$style.checkinMockHeaderSubtitle">링꾹 라이브 콘서트</span>
              </div>
              <span :class="$style.checkinMockStatsBadge">12 / 24명</span>
            </div>

            <!-- 카메라 + QR 스캔 영역 -->
            <div :class="$style.checkinMockCamera">
              <div :class="$style.checkinMockScanFrame">
                <span :class="[$style.checkinMockScanCorner, $style.checkinMockScanCornerTL]"></span>
                <span :class="[$style.checkinMockScanCorner, $style.checkinMockScanCornerTR]"></span>
                <span :class="[$style.checkinMockScanCorner, $style.checkinMockScanCornerBL]"></span>
                <span :class="[$style.checkinMockScanCorner, $style.checkinMockScanCornerBR]"></span>
                <div :class="$style.checkinMockScanLine"></div>
                <!-- QR 그래픽 (느낌만) -->
                <div :class="$style.checkinMockQr">
                  <span></span><span></span><span></span><span></span>
                  <span></span><span></span><span></span><span></span>
                  <span></span><span></span><span></span><span></span>
                  <span></span><span></span><span></span><span></span>
                </div>
              </div>
              <p :class="$style.checkinMockScanHint">QR을 프레임 안에 비춰주세요</p>
            </div>

            <!-- 결과 패널 (입장 가능) -->
            <div :class="$style.checkinMockResult">
              <div :class="$style.checkinMockResultStatusRow">
                <span :class="$style.checkinMockResultStatusBadge">✓ 입장 가능</span>
                <span :class="$style.checkinMockResultClose">✕</span>
              </div>
              <div :class="$style.checkinMockResultInfo">
                <div :class="$style.checkinMockResultNameRow">
                  <span :class="$style.checkinMockResultName">홍길동</span>
                  <span :class="$style.checkinMockResultTicketNo">#0024</span>
                </div>
                <div :class="$style.checkinMockResultQty">티켓 2매 · 일반석</div>
              </div>
              <div :class="$style.checkinMockResultBtn">입장 확인</div>
            </div>
          </div>
        </div>

        <ul :class="$style.featureRows">
          <li :class="$style.featureRow">
            <span :class="$style.featureRowNum">01</span>
            <div>
              <h4 :class="$style.featureRowTitle">QR 한 번에 예약 정보 확인</h4>
              <p :class="$style.featureRowDesc">
                예매자에게 발송된 입장 QR을 카메라로 스캔하면, 예약자 이름·티켓 수량·추가구매·티켓 패키지까지 한 화면에서 확인할 수 있어요.
              </p>
            </div>
          </li>

          <li :class="$style.featureRow">
            <span :class="$style.featureRowNum">02</span>
            <div>
              <h4 :class="$style.featureRowTitle">취소·미결제 티켓 자동 차단</h4>
              <p :class="$style.featureRowDesc">
                취소·환불한 티켓이나 결제·확정되지 않은 티켓은 자동으로 경고가 표시돼요. 잘못된 입장을 사전에 막아 현장 운영의 부담을 덜어드립니다.
              </p>
            </div>
          </li>

          <li :class="$style.featureRow">
            <span :class="$style.featureRowNum">03</span>
            <div>
              <h4 :class="$style.featureRowTitle">실시간 입장 현황 집계</h4>
              <p :class="$style.featureRowDesc">
                상단의 입장 카운터에서 전체 예매 인원 대비 입장 완료 인원이 실시간으로 집계돼요. 운영 상황을 한눈에 파악하고, 입장 후 다음 스캔으로 자동 전환됩니다.
              </p>
            </div>
          </li>

          <li :class="$style.featureRow">
            <span :class="$style.featureRowNum">04</span>
            <div>
              <h4 :class="$style.featureRowTitle">입장 결과 음성 안내</h4>
              <p :class="$style.featureRowDesc">
                입장 결과는 음성 읽기(TTS)로도 안내돼 사람이 많을 때 스크린 확인 부담을 줄일 수 있어요.
              </p>
            </div>
          </li>
        </ul>
      </div>
    </section>

    <!-- 함께한 공연 레퍼런스 -->
    <section v-if="referencesLoading || references.length > 0" :class="$style.section" id="references">
      <p :class="$style.eyebrowAlt">REFERENCES</p>
      <h2 :class="$style.sectionTitle">함께한 공연들</h2>
      <p :class="$style.sectionLeadShort">
        링꾹 예매·운영과 함께 진행된 공연 사례예요. 포스터를 누르면 공연 상세로 이동해요.
      </p>

      <!-- 스켈레톤 (로딩 중) — 가로 흐름 프리뷰 -->
      <div v-if="referencesLoading" :class="$style.referenceMarqueeWrap">
        <div :class="$style.referenceMarquee">
          <div :class="$style.referenceTrack">
            <div v-for="slot in skeletonMarqueeSlots" :key="slot.key"
              :class="[$style.referenceCard, $style.referenceSkeleton]" :aria-hidden="slot.dup ? true : undefined">
              <div :class="$style.referenceImgWrap"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- 실제 카드 — 왼쪽→오른쪽 무한 흐름 (포스터만) -->
      <div v-else :class="$style.referenceMarqueeWrap">
        <div :class="$style.referenceMarquee">
          <div :class="$style.referenceTrack">
            <div v-for="slot in referenceMarqueeSlots" :key="slot.key" :class="$style.referenceCard" role="button"
              :tabindex="slot.dup ? -1 : 0" :aria-hidden="slot.dup ? true : undefined"
              :aria-label="slot.dup ? undefined : referenceCardAriaLabel(slot.live)" :title="slot.live.title || '공연 상세'"
              @click="goToLive(slot.live)" @keydown="onReferenceCardKeydown($event, slot.live)">
              <div :class="$style.referenceImgWrap">
                <img v-if="slot.live.imgUrl" :src="slot.live.imgUrl" :alt="''" :class="$style.referenceImg"
                  loading="lazy" />
                <div v-else :class="$style.referenceImgPlaceholder">
                  {{ (slot.live.title || "?").charAt(0) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 부가 서비스 (인라인 컴팩트) -->
    <section :class="$style.section" id="organizer-addons">
      <p :class="$style.eyebrowAlt">ADD-ONS</p>
      <h2 :class="$style.sectionTitle">전문가 연결 서비스</h2>
      <p :class="$style.sectionLeadShort">
        공연에 필요한 전문 인력을 연결해드립니다. <span :class="$style.subNote">* 별도 문의</span>
      </p>

      <div :class="$style.addonRow">
        <div :class="$style.addonItem">
          <h4 :class="$style.addonItemTitle">디자인</h4>
          <p :class="$style.addonItemDesc">포스터 · 홍보물 · 굿즈 시안</p>
        </div>
        <div :class="$style.addonItem">
          <h4 :class="$style.addonItemTitle">오디오 믹싱</h4>
          <p :class="$style.addonItemDesc">공연용 INST · 라이브 사운드 최적화</p>
        </div>
        <div :class="$style.addonItem">
          <h4 :class="$style.addonItemTitle">전문 인력</h4>
          <p :class="$style.addonItemDesc">전문 MC 섭외 · 사진/영상 촬영</p>
        </div>
      </div>

      <!-- 운영자 문의 CTA -->
      <!-- <div :class="$style.organizerCta">
        <div>
          <h3 :class="$style.organizerCtaTitle">공연 운영, 함께 만들어볼까요?</h3>
          <p :class="$style.organizerCtaDesc">
            규모·일정·예산에 맞춘 맞춤 제안을 드립니다.
            <br />
            <span :class="$style.subNote">* 무료 이벤트 진행중</span>
          </p>
        </div>
        <button :class="[$style.cta, $style.ctaPrimary]" @click="openKakao">
          카카오톡으로 상담 신청
        </button>
      </div> -->
    </section>

    <!-- 자주 묻는 질문 -->
    <!-- <section :class="$style.section">
      <p :class="$style.eyebrow">FAQ</p>
      <h2 :class="$style.sectionTitle">자주 묻는 질문</h2>

      <div :class="$style.faqList">
        <details v-for="(faq, idx) in faqs" :key="idx" :class="$style.faqItem">
          <summary :class="$style.faqQ">{{ faq.q }}</summary>
          <p :class="$style.faqA" v-html="faq.a"></p>
        </details>
      </div>
    </section> -->

    <!-- CTA -->
    <section :class="$style.ctaSection">
      <h2 :class="$style.ctaTitle">지금 바로 시작해볼까요?</h2>
      <p :class="$style.ctaDesc">카카오톡 채널로 부담 없이 문의해주세요.
      </p>
      <div :class="$style.ctaButtons">
        <button :class="[$style.cta, $style.ctaPrimary]" @click="goTo('/')">
          홈으로 가기
        </button>
        <button :class="[$style.cta, $style.ctaGhost]" @click="openKakao">
          문의하기
        </button>
      </div>
    </section>

    <!-- 회사 정보 (간략) -->
    <section :class="$style.companyBox">
      <h3 :class="$style.companyTitle">운영사 정보</h3>
      <ul :class="$style.companyList">
        <li>
          <span :class="$style.companyListLabel">상호명</span>
          <span :class="$style.companyListValue">링꾹</span>
        </li>
        <li>
          <span :class="$style.companyListLabel">대표</span>
          <span :class="$style.companyListValue">이민경</span>
        </li>
        <li>
          <span :class="$style.companyListLabel">사업자등록번호</span>
          <span :class="$style.companyListValue">897-07-03002</span>
        </li>
        <li>
          <span :class="$style.companyListLabel">주소</span>
          <span :class="$style.companyListValue">서울특별시 강서구 마곡중앙2로 15, 1층 103호</span>
        </li>
        <li>
          <span :class="$style.companyListLabel">문의</span>
          <span :class="$style.companyListValue">070-8019-3736</span>
        </li>
        <li>
          <span :class="$style.companyListLabel">통신판매업 신고번호</span>
          <span :class="$style.companyListValue">제 2026-서울강서-0767 호</span>
        </li>
      </ul>
      <!-- <p :class="$style.companyNotice">
        링꾹라이브는 아티스트와 관객이 만나는 공간을 제공하며,
        실제 상품과 거래에 대한 책임은 판매 회원에게 있습니다.
      </p> -->
    </section>
  </div>
</template>

<script>
import { setPageMeta } from "@/utils/pageMeta";
import { firestore, storage } from "/firebaseConfig";
import { collection, query, where, getDocs } from "firebase/firestore";
import { ref as storageRef } from "firebase/storage";
import { getDownloadURL } from "@/utils/storageWithNavigation";
import { parse } from "date-fns";
import QRCode from "qrcode";

export default {
  name: "AboutService",
  data() {
    return {
      references: [],
      referencesLoading: true,
      aboutQrDemoUrl: "",
      isQrViewActive: false,
      alimtalkDemoCursorVisible: false,
      alimtalkDemoCursorTransform: "translate(0px, 0px)",
      alimtalkDemoCursorMoving: false,
      alimtalkDemoCursorPressing: false,
      alimtalkDemoBtnPressing: false,
      alimtalkDemoBackBtnPressing: false,
      alimtalkDemoLoopRunning: false,
      alimtalkDemoTimeoutIds: [],
      alimtalkDemoSectionIo: null,
      formMockPackageTier: "special",
      formMockTotalBump: false,
      formMockBasicDemoPress: false,
      formBuilderDemoCursorVisible: false,
      formBuilderDemoCursorTransform: "translate(0px, 0px)",
      formBuilderDemoCursorMoving: false,
      formBuilderDemoCursorPressing: false,
      formBuilderDemoLoopRunning: false,
      formBuilderDemoTimeoutIds: [],
      formBuilderDemoSectionIo: null,
      formMockCheerStickQty: 1,
      formMockCheerPlusDemoPress: false,
      reservationDemoPhase: 0,
      reservationDemoPulseRow: -1,
      reservationDemoLoopRunning: false,
      reservationDemoTimeoutIds: [],
      reservationDemoSectionIo: null,
      faqs: [
        {
          q: "링꾹라이브는 어떤 서비스인가요?",
          a: "밴드·댄스·일러스트·코스프레 등 서브컬처 장르의 라이브공연과 아티스트 정보를 한곳에서 찾을 수 있는 플랫폼이에요. 관객에게는 공연 탐색·예매·커뮤니티를, 주최자·아티스트에게는 홍보·예매·현장 운영을 포함한 통합 솔루션을 제공합니다.",
        },
        {
          q: "관객의 이용 요금이 있나요?",
          a: "회원 가입과 기본 기능(공연 탐색, 찜, 커뮤니티 이용 등)은 모두 <b>무료</b>입니다. 공연 티켓 비용은 각 공연 주최자가 정한 가격으로 결제됩니다.",
        },
        {
          q: "공연을 등록하거나 우리 팀(아티스트) 페이지를 만들고 싶어요.",
          a: "카카오톡에서 <b>‘링꾹’ 비즈니스 채널</b>을 검색해 문의해주세요. 공연 등록, 아티스트 페이지 개설, 홍보 배너 안내까지 도와드립니다.",
        },
        {
          q: "공연관리 서비스는 정확히 어떤 것을 도와주나요?",
          a: "① <b>SNS 홍보 지원</b>(인스타그램·트위터 공식 채널 노출), ② <b>실시간 예매 트래킹과 자동 정산 리포트</b>, ③ <b>현장 스태프(최대 4명) 지원</b>(QR 체크인·입장 팔찌 배부 등 동선 관리)이 기본 제공됩니다. 디자인·오디오 믹싱·MC 섭외·촬영은 별도 견적의 부가 서비스로 신청할 수 있어요.",
        },
        {
          q: "예매관리 시스템에서 어떤 기능을 사용할 수 있나요?",
          a: "대기중/확정/취소 <b>상태별 필터링</b>, 이름·이메일 <b>스마트 검색</b>, 굿즈·부가 서비스 <b>추가 구매 항목 통합 관리</b>, 입금 확인 클릭 시 <b>티켓 번호 발급 + 카카오 알림톡 자동 발송</b>, <b>중복 없는 고유 티켓 번호</b>, 선착순 분석을 위한 <b>초 단위 신청 이력</b>까지 한 화면에서 운영할 수 있어요.",
        },
        {
          q: "예매한 티켓은 어디서 확인하나요?",
          a: "로그인 후 우측 상단 프로필 메뉴 → <b>예매내역</b>에서 확인할 수 있어요. 입장 시 QR 코드를 보여주시면 현장 체크인이 가능합니다.",
        },
        {
          q: "서비스 이용 중 문제가 발생했어요.",
          a: "카카오톡 ‘링꾹’ 비즈니스 채널 또는 070-8019-3736으로 연락 주세요. contact@linkook.live 로도 문의하실 수 있습니다.",
        },
      ],
    };
  },
  computed: {
    /** 무한 가로 스크롤용: 동일 목록을 두 번 이어 붙임 (translate -50% 루프) */
    referenceMarqueeSlots() {
      return [
        ...this.references.map((live) => ({
          live,
          key: String(live.id),
          dup: false,
        })),
        ...this.references.map((live) => ({
          live,
          key: `d-${live.id}`,
          dup: true,
        })),
      ];
    },
    /** 홈 목업: 정렬상 최신 레퍼런스(첫 번째)는 제외 — 하단 레퍼런스와 겹침 완화 */
    aboutMockReferencesForHome() {
      return this.references.slice(1);
    },
    /** ABOUT 목업 타일 — 위 목록에서 상위 3개 */
    aboutMockTileLives() {
      return this.aboutMockReferencesForHome.slice(0, 3);
    },
    skeletonMarqueeSlots() {
      const idx = [0, 1, 2, 3, 4, 5, 6, 7];
      return [
        ...idx.map((i) => ({ key: `sk-a-${i}`, dup: false })),
        ...idx.map((i) => ({ key: `sk-b-${i}`, dup: true })),
      ];
    },
    formMockCheerStickSubtotal() {
      return this.formMockCheerStickQty * 12000;
    },
    formMockPackagePriceNum() {
      return this.formMockPackageTier === "special" ? 80000 : 30000;
    },
    formMockTotalAmount() {
      return this.formMockPackagePriceNum + this.formMockCheerStickSubtotal;
    },
    formMockTotalFormatted() {
      return `${this.formMockTotalAmount.toLocaleString("ko-KR")}원`;
    },
    formMockCheerLineSubtotal() {
      return `${this.formMockCheerStickSubtotal.toLocaleString("ko-KR")}원`;
    },
    formMockCalcSummary() {
      const tier = this.formMockPackageTier === "special" ? "SPECIAL" : "BASIC";
      const pkg = this.formMockPackagePriceNum.toLocaleString("ko-KR");
      const cheer = this.formMockCheerStickSubtotal.toLocaleString("ko-KR");
      return `${tier} ${pkg} + 응원봉 세트×${this.formMockCheerStickQty} (${cheer}원)`;
    },
  },
  created() {
    setPageMeta({
      title: "서비스 안내",
      description:
        "링꾹라이브는 서브컬처 라이브공연/아티스트 플랫폼입니다. 관객을 위한 공연 탐색·예매·QR 입장, 주최자·아티스트를 위한 공연관리·예매관리 통합 솔루션을 제공합니다.",
    });
    this.fetchReferences();
  },
  mounted() {
    this.loadAboutQrDemo();
    this.setupAlimtalkDemoObserver();
    this.setupFormBuilderDemoObserver();
    this.setupReservationDemoObserver();
  },
  beforeUnmount() {
    if (this.alimtalkDemoSectionIo) {
      this.alimtalkDemoSectionIo.disconnect();
      this.alimtalkDemoSectionIo = null;
    }
    this.stopAlimtalkDemoLoop();
    if (this.formBuilderDemoSectionIo) {
      this.formBuilderDemoSectionIo.disconnect();
      this.formBuilderDemoSectionIo = null;
    }
    this.stopFormBuilderDemoLoop();
    if (this.reservationDemoSectionIo) {
      this.reservationDemoSectionIo.disconnect();
      this.reservationDemoSectionIo = null;
    }
    this.clearReservationDemoTimers();
  },
  methods: {
    goTo(path) {
      if (!path) return;
      this.$router.push(path);
    },
    openKakao() {
      window.open("http://pf.kakao.com/_sIxgZX", "_blank");
    },
    scrollTo(id) {
      const el = document.getElementById(id);
      if (!el) return;
      const y = el.getBoundingClientRect().top + window.pageYOffset - 20;
      window.scrollTo({ top: y, behavior: "smooth" });
    },
    clearAlimtalkDemoTimers() {
      if (this.alimtalkDemoTimeoutIds.length) {
        this.alimtalkDemoTimeoutIds.forEach((tid) => clearTimeout(tid));
        this.alimtalkDemoTimeoutIds = [];
      }
    },
    pushAlimtalkDemoTimeout(fn, ms) {
      const tid = setTimeout(fn, ms);
      this.alimtalkDemoTimeoutIds.push(tid);
    },
    stopAlimtalkDemoLoop() {
      this.clearAlimtalkDemoTimers();
      this.alimtalkDemoLoopRunning = false;
      this.isQrViewActive = false;
      this.resetAlimtalkDemoCursorVisual();
    },
    startAlimtalkDemoLoop() {
      if (typeof window === "undefined") return;
      if (this.alimtalkDemoLoopRunning) return;
      this.alimtalkDemoLoopRunning = true;
      this.clearAlimtalkDemoTimers();
      this.isQrViewActive = false;
      this.resetAlimtalkDemoCursorVisual();

      const reduceMotion =
        window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (reduceMotion) {
        this.pushAlimtalkDemoTimeout(() => {
          this.openAlimtalkQrDemoToQrView();
          this.alimtalkDemoLoopRunning = false;
        }, 650);
        return;
      }
      this.runAlimtalkDemoCycle();
    },
    resetAlimtalkDemoCursorVisual() {
      this.alimtalkDemoCursorVisible = false;
      this.alimtalkDemoCursorMoving = false;
      this.alimtalkDemoCursorPressing = false;
      this.alimtalkDemoBtnPressing = false;
      this.alimtalkDemoBackBtnPressing = false;
      this.alimtalkDemoCursorTransform = "translate(0px, 0px)";
    },
    setupAlimtalkDemoObserver() {
      if (typeof window === "undefined" || !("IntersectionObserver" in window)) return;
      this.$nextTick(() => {
        if (this.alimtalkDemoSectionIo) {
          this.alimtalkDemoSectionIo.disconnect();
          this.alimtalkDemoSectionIo = null;
        }
        const section = document.getElementById("alimtalk-qr");
        if (!section) return;
        const io = new IntersectionObserver(
          (entries) => {
            const e = entries[0];
            if (!e) return;
            if (e.isIntersecting && e.intersectionRatio >= 0.14) {
              this.startAlimtalkDemoLoop();
            } else if (!e.isIntersecting) {
              this.stopAlimtalkDemoLoop();
            }
          },
          { threshold: [0, 0.12, 0.2, 0.35] }
        );
        io.observe(section);
        this.alimtalkDemoSectionIo = io;
      });
    },
    /** 자동 데모 루프용: 타이머를 끊지 않고 QR 화면만 연다 */
    openAlimtalkQrDemoToQrView() {
      this.resetAlimtalkDemoCursorVisual();
      this.isQrViewActive = true;
    },
    /** 자동 데모 루프용: ← 알림톡 버튼 누른 것과 동일 화면 전환 (타이머 유지) */
    openAlimtalkFromQrDemo() {
      this.alimtalkDemoBackBtnPressing = false;
      this.alimtalkDemoCursorPressing = false;
      this.alimtalkDemoCursorVisible = false;
      this.alimtalkDemoCursorMoving = false;
      this.alimtalkDemoCursorTransform = "translate(0px, 0px)";
      this.isQrViewActive = false;
    },
    runAlimtalkDemoCycle() {
      if (typeof window === "undefined") return;
      if (!this.alimtalkDemoLoopRunning) return;
      if (this.isQrViewActive) return;

      this.$nextTick(() => {
        const stage = this.$refs.alimtalkQrStage;
        const btn = this.$refs.alimtalkQrLinkBtn;
        if (!stage || !btn || this.isQrViewActive) {
          this.stopAlimtalkDemoLoop();
          return;
        }
        const s = stage.getBoundingClientRect();
        const b = btn.getBoundingClientRect();
        const tipOffsetX = 4;
        const tipOffsetY = 2;
        const targetX = b.left + b.width * 0.48 - s.left - tipOffsetX;
        const targetY = b.top + b.height * 0.55 - s.top - tipOffsetY;
        const startX = Math.max(6, Math.min(s.width * 0.78, s.width - 36));
        const startY = Math.max(10, s.height * 0.22);

        this.alimtalkDemoBtnPressing = false;
        this.alimtalkDemoCursorPressing = false;
        this.alimtalkDemoCursorMoving = false;
        this.alimtalkDemoCursorTransform = `translate(${startX}px, ${startY}px)`;
        this.alimtalkDemoCursorVisible = true;

        this.$nextTick(() => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.alimtalkDemoCursorMoving = true;
              this.alimtalkDemoCursorTransform = `translate(${targetX}px, ${targetY}px)`;
            });
          });
        });

        const moveMs = 1080;
        const holdQrMs = 1800;
        const legBack = 1080;
        const pauseBeforeRepeatMs = 900;
        const tOpenQr = moveMs + 240;
        const tBackMoveStart = tOpenQr + holdQrMs;
        const tBackPress = tBackMoveStart + legBack + 30;
        const tBackGo = tBackMoveStart + legBack + 200;

        this.pushAlimtalkDemoTimeout(() => {
          if (this.isQrViewActive) return;
          this.alimtalkDemoCursorPressing = true;
          this.alimtalkDemoBtnPressing = true;
        }, moveMs + 30);

        this.pushAlimtalkDemoTimeout(() => {
          if (this.isQrViewActive) return;
          this.openAlimtalkQrDemoToQrView();
        }, tOpenQr);

        this.pushAlimtalkDemoTimeout(() => {
          if (!this.alimtalkDemoLoopRunning || !this.isQrViewActive) return;
          this.$nextTick(() => {
            const stage2 = this.$refs.alimtalkQrStage;
            const backBtn = this.$refs.alimtalkQrBackBtn;
            if (!stage2 || !backBtn) {
              this.stopAlimtalkDemoLoop();
              return;
            }
            const s2 = stage2.getBoundingClientRect();
            const br = backBtn.getBoundingClientRect();
            const tipX = 4;
            const tipY = 2;
            const targetXb = br.left + br.width * 0.48 - s2.left - tipX;
            const targetYb = br.top + br.height * 0.55 - s2.top - tipY;
            const startXb = Math.max(6, Math.min(s2.width * 0.7, s2.width - 36));
            const startYb = Math.max(10, s2.height * 0.48);

            this.alimtalkDemoCursorPressing = false;
            this.alimtalkDemoCursorMoving = false;
            this.alimtalkDemoCursorTransform = `translate(${startXb}px, ${startYb}px)`;
            this.alimtalkDemoCursorVisible = true;

            this.$nextTick(() => {
              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  this.alimtalkDemoCursorMoving = true;
                  this.alimtalkDemoCursorTransform = `translate(${targetXb}px, ${targetYb}px)`;
                });
              });
            });
          });
        }, tBackMoveStart);

        this.pushAlimtalkDemoTimeout(() => {
          if (!this.isQrViewActive) return;
          this.alimtalkDemoCursorPressing = true;
          this.alimtalkDemoBackBtnPressing = true;
        }, tBackPress);

        this.pushAlimtalkDemoTimeout(() => {
          if (!this.alimtalkDemoLoopRunning || !this.isQrViewActive) return;
          this.openAlimtalkFromQrDemo();
        }, tBackGo);

        this.pushAlimtalkDemoTimeout(() => {
          if (!this.alimtalkDemoLoopRunning) return;
          this.runAlimtalkDemoCycle();
        }, tBackGo + pauseBeforeRepeatMs);
      });
    },
    clearFormBuilderDemoTimers() {
      if (this.formBuilderDemoTimeoutIds.length) {
        this.formBuilderDemoTimeoutIds.forEach((tid) => clearTimeout(tid));
        this.formBuilderDemoTimeoutIds = [];
      }
    },
    pushFormBuilderDemoTimeout(fn, ms) {
      const tid = setTimeout(fn, ms);
      this.formBuilderDemoTimeoutIds.push(tid);
    },
    resetFormBuilderDemoCursorVisual() {
      this.formBuilderDemoCursorVisible = false;
      this.formBuilderDemoCursorMoving = false;
      this.formBuilderDemoCursorPressing = false;
      this.formMockBasicDemoPress = false;
      this.formMockCheerPlusDemoPress = false;
      this.formBuilderDemoCursorTransform = "translate(0px, 0px)";
    },
    stopFormBuilderDemoLoop() {
      this.clearFormBuilderDemoTimers();
      this.formBuilderDemoLoopRunning = false;
      this.resetFormBuilderDemoCursorVisual();
      this.formMockPackageTier = "special";
      this.formMockCheerStickQty = 1;
    },
    startFormBuilderDemoLoop() {
      if (typeof window === "undefined") return;
      if (this.formBuilderDemoLoopRunning) return;
      this.formBuilderDemoLoopRunning = true;
      this.clearFormBuilderDemoTimers();
      this.formMockPackageTier = "special";
      this.formMockCheerStickQty = 1;

      const reduceMotion =
        window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (reduceMotion) {
        this.pushFormBuilderDemoTimeout(() => {
          this.setFormMockPackageTier("basic");
          this.formMockCheerStickQty = 3;
          this.bumpFormMockTotal();
          this.formBuilderDemoLoopRunning = false;
        }, 700);
        return;
      }
      this.runFormBuilderDemoCycle();
    },
    setupFormBuilderDemoObserver() {
      if (typeof window === "undefined" || !("IntersectionObserver" in window)) return;
      this.$nextTick(() => {
        if (this.formBuilderDemoSectionIo) {
          this.formBuilderDemoSectionIo.disconnect();
          this.formBuilderDemoSectionIo = null;
        }
        const section = document.getElementById("booking-form");
        if (!section) return;
        const io = new IntersectionObserver(
          (entries) => {
            const e = entries[0];
            if (!e) return;
            if (e.isIntersecting && e.intersectionRatio >= 0.14) {
              this.startFormBuilderDemoLoop();
            } else if (!e.isIntersecting) {
              this.stopFormBuilderDemoLoop();
            }
          },
          { threshold: [0, 0.12, 0.2, 0.35] }
        );
        io.observe(section);
        this.formBuilderDemoSectionIo = io;
      });
    },
    runFormBuilderDemoCycle() {
      if (typeof window === "undefined") return;
      if (!this.formBuilderDemoLoopRunning) return;

      this.formMockPackageTier = "special";
      this.formMockCheerStickQty = 1;

      this.$nextTick(() => {
        const stage = this.$refs.formBuilderMockStage;
        const basicEl = this.$refs.formMockBasicPackageEl;
        const plusEl = this.$refs.formMockCheerPlusBtn;
        if (!stage || !basicEl || !plusEl) {
          this.stopFormBuilderDemoLoop();
          return;
        }

        const tipX = 4;
        const tipY = 2;
        const sr = () => stage.getBoundingClientRect();

        const startX = Math.max(8, Math.min(sr().width * 0.82, sr().width - 40));
        const startY = Math.max(12, sr().height * 0.12);

        const br = basicEl.getBoundingClientRect();
        const basicTx = br.left + br.width * 0.42 - sr().left - tipX;
        const basicTy = br.top + br.height * 0.48 - sr().top - tipY;

        const pr = () => plusEl.getBoundingClientRect();
        const plusTarget = () => {
          const r = pr();
          const s = sr();
          return {
            x: r.left + r.width * 0.55 - s.left - tipX,
            y: r.top + r.height * 0.5 - s.top - tipY,
          };
        };

        this.formMockBasicDemoPress = false;
        this.formMockCheerPlusDemoPress = false;
        this.formBuilderDemoCursorPressing = false;
        this.formBuilderDemoCursorMoving = false;
        this.formBuilderDemoCursorTransform = `translate(${startX}px, ${startY}px)`;
        this.formBuilderDemoCursorVisible = true;

        const leg1 = 1180;
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.formBuilderDemoCursorMoving = true;
              this.formBuilderDemoCursorTransform = `translate(${basicTx}px, ${basicTy}px)`;
            });
          });
        });

        this.pushFormBuilderDemoTimeout(() => {
          this.formBuilderDemoCursorPressing = true;
          this.formMockBasicDemoPress = true;
        }, leg1 + 40);

        this.pushFormBuilderDemoTimeout(() => {
          this.setFormMockPackageTier("basic");
        }, leg1 + 200);

        this.pushFormBuilderDemoTimeout(() => {
          this.formBuilderDemoCursorPressing = false;
          this.formMockBasicDemoPress = false;
        }, leg1 + 300);

        const pauseBeforePlus = 400;
        const leg2 = 960;
        const tStartLeg2 = leg1 + pauseBeforePlus;

        this.pushFormBuilderDemoTimeout(() => {
          const p = plusTarget();
          this.formBuilderDemoCursorMoving = false;
          this.$nextTick(() => {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                this.formBuilderDemoCursorMoving = true;
                this.formBuilderDemoCursorTransform = `translate(${p.x}px, ${p.y}px)`;
              });
            });
          });
        }, tStartLeg2);

        const tPlusReady = tStartLeg2 + leg2;

        const pulsePlusClick = (offset) => {
          this.pushFormBuilderDemoTimeout(() => {
            this.formBuilderDemoCursorPressing = true;
            this.formMockCheerPlusDemoPress = true;
          }, tPlusReady + offset);
          this.pushFormBuilderDemoTimeout(() => {
            this.incrementFormMockCheerStick();
          }, tPlusReady + offset + 85);
          this.pushFormBuilderDemoTimeout(() => {
            this.formBuilderDemoCursorPressing = false;
            this.formMockCheerPlusDemoPress = false;
          }, tPlusReady + offset + 165);
        };

        pulsePlusClick(45);
        pulsePlusClick(480);

        this.pushFormBuilderDemoTimeout(() => {
          this.formBuilderDemoCursorVisible = false;
          this.formBuilderDemoCursorMoving = false;
          this.formBuilderDemoCursorPressing = false;
        }, tPlusReady + 900);

        this.pushFormBuilderDemoTimeout(() => {
          if (!this.formBuilderDemoLoopRunning) return;
          this.runFormBuilderDemoCycle();
        }, tPlusReady + 1800);
      });
    },
    incrementFormMockCheerStick() {
      this.formMockCheerStickQty = Math.min(99, this.formMockCheerStickQty + 1);
      this.bumpFormMockTotal();
    },
    setFormMockPackageTier(tier) {
      const key = tier === "special" ? "special" : "basic";
      if (this.formMockPackageTier === key) return;
      this.formMockPackageTier = key;
      this.bumpFormMockTotal();
    },
    bumpFormMockTotal() {
      this.formMockTotalBump = true;
      const tid = setTimeout(() => {
        this.formMockTotalBump = false;
      }, 420);
      this.formBuilderDemoTimeoutIds.push(tid);
    },
    clearReservationDemoTimers() {
      if (this.reservationDemoTimeoutIds.length) {
        this.reservationDemoTimeoutIds.forEach((tid) => clearTimeout(tid));
        this.reservationDemoTimeoutIds = [];
      }
    },
    pushReservationDemoTimeout(fn, ms) {
      const tid = setTimeout(fn, ms);
      this.reservationDemoTimeoutIds.push(tid);
    },
    stopReservationDemoLoop() {
      this.clearReservationDemoTimers();
      this.reservationDemoLoopRunning = false;
      this.reservationDemoPhase = 0;
      this.reservationDemoPulseRow = -1;
    },
    startReservationDemoLoop() {
      if (typeof window === "undefined") return;
      if (this.reservationDemoLoopRunning) return;
      this.reservationDemoLoopRunning = true;
      this.clearReservationDemoTimers();
      this.reservationDemoPhase = 0;
      this.reservationDemoPulseRow = -1;

      const reduceMotion =
        window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (reduceMotion) {
        this.reservationDemoPhase = 3;
        this.reservationDemoLoopRunning = false;
        return;
      }
      this.runReservationDemoCycle();
    },
    runReservationDemoCycle() {
      if (!this.reservationDemoLoopRunning) return;

      this.reservationDemoPhase = 0;
      this.reservationDemoPulseRow = -1;

      this.pushReservationDemoTimeout(() => {
        if (!this.reservationDemoLoopRunning) return;
        this.reservationDemoPhase = 1;
        this.reservationDemoPulseRow = 0;
      }, 1600);
      this.pushReservationDemoTimeout(() => {
        if (!this.reservationDemoLoopRunning) return;
        this.reservationDemoPulseRow = -1;
      }, 2150);
      this.pushReservationDemoTimeout(() => {
        if (!this.reservationDemoLoopRunning) return;
        this.reservationDemoPhase = 2;
        this.reservationDemoPulseRow = 1;
      }, 3400);
      this.pushReservationDemoTimeout(() => {
        if (!this.reservationDemoLoopRunning) return;
        this.reservationDemoPulseRow = -1;
      }, 3950);
      this.pushReservationDemoTimeout(() => {
        if (!this.reservationDemoLoopRunning) return;
        this.reservationDemoPhase = 3;
        this.reservationDemoPulseRow = 2;
      }, 5200);
      this.pushReservationDemoTimeout(() => {
        if (!this.reservationDemoLoopRunning) return;
        this.reservationDemoPulseRow = -1;
      }, 5750);
      this.pushReservationDemoTimeout(() => {
        if (!this.reservationDemoLoopRunning) return;
        this.reservationDemoPhase = 0;
        this.reservationDemoPulseRow = -1;
      }, 7600);
      this.pushReservationDemoTimeout(() => {
        if (!this.reservationDemoLoopRunning) return;
        this.runReservationDemoCycle();
      }, 8200);
    },
    setupReservationDemoObserver() {
      if (typeof window === "undefined" || !("IntersectionObserver" in window)) return;
      this.$nextTick(() => {
        if (this.reservationDemoSectionIo) {
          this.reservationDemoSectionIo.disconnect();
          this.reservationDemoSectionIo = null;
        }
        const section = document.getElementById("reservation-management");
        if (!section) return;
        const io = new IntersectionObserver(
          (entries) => {
            const e = entries[0];
            if (!e) return;
            if (e.isIntersecting && e.intersectionRatio >= 0.14) {
              this.startReservationDemoLoop();
            } else if (!e.isIntersecting) {
              this.stopReservationDemoLoop();
            }
          },
          { threshold: [0, 0.12, 0.2, 0.35] }
        );
        io.observe(section);
        this.reservationDemoSectionIo = io;
      });
    },
    reservationDemoStatusKind(rowIdx) {
      const p = this.reservationDemoPhase;
      if (rowIdx === 3) return "entered";
      if (rowIdx === 0) return p >= 1 ? "ok" : "wait";
      if (rowIdx === 1) return p >= 2 ? "cancel" : "ok";
      if (rowIdx === 2) return p >= 3 ? "refund" : "ok";
      return "ok";
    },
    reservationDemoStatusClass(rowIdx) {
      const k = this.reservationDemoStatusKind(rowIdx);
      if (k === "wait") return this.$style.mockStatusWait;
      if (k === "ok") return this.$style.mockStatusOk;
      if (k === "cancel") return this.$style.mockStatusCancel;
      if (k === "refund") return this.$style.mockStatusRefund;
      return this.$style.mockStatusEntered;
    },
    reservationDemoStatusText(rowIdx) {
      const k = this.reservationDemoStatusKind(rowIdx);
      if (k === "wait") return "대기중";
      if (k === "ok") return "확정";
      if (k === "cancel") return "취소";
      if (k === "refund") return "환불";
      return "✓ 입장";
    },
    showQrView() {
      this.clearAlimtalkDemoTimers();
      this.resetAlimtalkDemoCursorVisual();
      this.isQrViewActive = true;
      this.alimtalkDemoLoopRunning = false;
    },
    showAlimtalkView() {
      this.stopAlimtalkDemoLoop();
    },
    async loadAboutQrDemo() {
      try {
        const origin =
          typeof window !== "undefined" && window.location?.origin
            ? window.location.origin
            : "https://linkook.live";
        this.aboutQrDemoUrl = await QRCode.toDataURL(`${origin}/qr/sample-ticket`, {
          width: 260,
          margin: 1,
          errorCorrectionLevel: "M",
          color: { dark: "#0f172a", light: "#ffffff" },
        });
      } catch {
        this.aboutQrDemoUrl = "";
      }
    },
    /**
     * 서비스 안내(/about)에 노출할 공연 — Firestore `aboutReference: true` 인 라이브만.
     * 승인된 공연만 표시, 날짜 내림차순으로 상위 N개.
     */
    async fetchReferences() {
      try {
        this.referencesLoading = true;
        const q = query(
          collection(firestore, "lives"),
          where("aboutReference", "==", true)
        );
        const snapshot = await getDocs(q);

        const parseReservationStr = (s) => {
          if (typeof s !== "string") return null;
          const m = /^(\d{4})\.(\d{2})\.(\d{2}) (\d{2}):(\d{2})$/.exec(s.trim());
          if (!m) return null;
          return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), Number(m[4]), Number(m[5]));
        };

        const items = snapshot.docs
          .map((docSnap) => {
            const data = docSnap.data();
            if (data.status === "draft") return null;
            if (!data.approved) return null;

            let isReservationOpened = false;
            let isReservationClosed = false;
            if (data.linkookReservation) {
              const now = new Date();
              const reservationStartDate = parseReservationStr(data.reservationStartDate);
              const reservationEndDate = parseReservationStr(data.reservationEndDate);
              isReservationOpened = reservationStartDate ? now >= reservationStartDate : false;
              isReservationClosed = reservationEndDate ? now > reservationEndDate : false;
            }

            const lineupRaw = data.lineup;
            const lineup = Array.isArray(lineupRaw)
              ? lineupRaw.map((x) => (typeof x === "string" ? x.trim() : String(x))).filter(Boolean)
              : [];

            return {
              id: docSnap.id,
              slug: data.slug || docSnap.id,
              title: data.title || "",
              date: data.date || "",
              place: data.place || "",
              img: data.img || "",
              imgUrl: null,
              lineup,
              type: data.type || "other",
              linkookReservation: !!data.linkookReservation,
              isReservationOpened,
              isReservationClosed,
            };
          })
          .filter(Boolean)
          // 날짜 내림차순 (yyyy.MM.dd 기준)
          .sort((a, b) => {
            const ka = (a.date || "").substring(0, 10).replace(/\./g, "");
            const kb = (b.date || "").substring(0, 10).replace(/\./g, "");
            return kb.localeCompare(ka);
          })
          .slice(0, 12);

        this.references = items;
        this.referencesLoading = false;

        // 포스터 이미지는 비동기로 채워 넣음
        // 주의: this.references를 통해 접근해야 reactive proxy로 동작 → 화면 갱신됨
        await Promise.all(
          this.references.map(async (item) => {
            if (!item.img) return;
            if (item.img.startsWith("http")) {
              item.imgUrl = item.img;
              return;
            }
            try {
              const imageRef = storageRef(storage, `poster/${item.img}`);
              item.imgUrl = await getDownloadURL(imageRef);
            } catch (e) {
              // 이미지 로드 실패는 무시 (placeholder로 표시)
              console.warn(`포스터 이미지 로드 실패: poster/${item.img}`, e);
              item.imgUrl = null;
            }
          })
        );
      } catch (error) {
        console.error("레퍼런스 라이브 가져오기 실패:", error);
        this.references = [];
        this.referencesLoading = false;
      }
    },
    formatRefDate(dateStr) {
      if (!dateStr) return "";
      // "2025.06.15 19:00" → "2025.06.15"
      return dateStr.substring(0, 10);
    },
    formatLineupForAbout(lineup) {
      if (!lineup || !Array.isArray(lineup) || !lineup.length) return "";
      return lineup.join(", ");
    },
    aboutMockMarqueeLine(live) {
      if (!live) return "";
      const title = live.title || "제목 없음";
      const date = this.formatRefDate(live.date) || "날짜 미정";
      const place = live.place || "장소 미정";
      const lineup = this.formatLineupForAbout(live.lineup) || "라인업 미정";
      return `🎵 ${title} | ${date} | ${place} | ${lineup}`;
    },
    /** LiveList.calculateDaysLeft 와 동일 규칙 */
    aboutMockCalculateDaysLeft(live) {
      const targetDate = live && live.date;
      if (!targetDate || typeof targetDate !== "string") return "";
      const substrDate = targetDate.substring(0, 10);
      if (!substrDate) return "";
      const now = new Date();
      const eventDate = parse(substrDate, "yyyy.MM.dd", new Date());
      if (Number.isNaN(eventDate.getTime())) return "";

      const nowMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const eventMidnight = new Date(
        eventDate.getFullYear(),
        eventDate.getMonth(),
        eventDate.getDate()
      );
      const daysLeft = Math.ceil((eventMidnight - nowMidnight) / (1000 * 60 * 60 * 24));
      return daysLeft === 0 ? "D-DAY" : daysLeft > 0 ? `D-${daysLeft}` : "종료";
    },
    aboutMockDdayPillClass(live) {
      const label = this.aboutMockCalculateDaysLeft(live);
      if (label === "종료") return this.$style.aboutMockDdayEnded;
      const hot = label === "D-DAY" || label === "D-1" || label === "D-2";
      return [this.$style.aboutMockDday, hot ? this.$style.aboutMockDdayHot : null];
    },
    aboutMockShowLinkookLabel(live) {
      return (
        !!live &&
        live.linkookReservation &&
        live.isReservationOpened &&
        !live.isReservationClosed
      );
    },
    aboutMockTypeImg(type) {
      /** 정적 require만 사용 (동적 require·eslint-disable 불필요). other.png 없음 → mix.png */
      const poster = {
        vocal: require("@/assets/images/vocal.png"),
        band: require("@/assets/images/band.png"),
        dance: require("@/assets/images/dance.png"),
        other: require("@/assets/images/mix.png"),
      };
      const key = type && Object.prototype.hasOwnProperty.call(poster, type) ? type : "other";
      return poster[key];
    },
    aboutMockGradStops(idx) {
      const variants = [
        { from: "#a5b4fc", to: "#6366f1" },
        { from: "#fbcfe8", to: "#ec4899" },
        { from: "#99f6e4", to: "#14b8a6" },
      ];
      return variants[(idx || 0) % 3];
    },
    referenceCardAriaLabel(live) {
      if (!live) return "공연 상세 보기";
      const parts = [live.title, this.formatRefDate(live.date), live.place].filter(Boolean);
      return (parts.length ? parts.join(" · ") : "공연") + " 상세 페이지로 이동";
    },
    onReferenceCardKeydown(event, live) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        this.goToLive(live);
      }
    },
    goToLive(live) {
      if (!live) return;
      this.$router.push({
        name: "LiveDetail",
        params: { slug: live.slug || live.id },
      });
    },
  },
};
</script>

<style module>
/* ================================================
   페이지 컨테이너
   ================================================ */
.page {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  color: #1f2937;
  font-family: var(--font-nanum-r), sans-serif;
}

/* ================================================
   HERO
   ================================================ */
.hero {
  position: relative;
  width: 100%;
  padding: 88px 24px 96px;
  overflow: hidden;
  background: linear-gradient(160deg, #f0f7ff 0%, #eaf1ff 35%, #f5f0fa 100%);
  border-bottom: 1px solid rgba(102, 189, 255, 0.12);
}

.heroInner {
  position: relative;
  z-index: 1;
  max-width: 760px;
  margin: 0 auto;
  text-align: center;
}

.heroLogo {
  display: block;
  width: 220px;
  height: auto;
  margin: 0 auto 28px;
}

.heroTag {
  display: inline-block;
  margin: 0 auto 26px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 700;
  color: #2a8be0;
  background: rgba(102, 189, 255, 0.15);
  border-radius: 999px;
  letter-spacing: 0.02em;
  font-family: "NanumSquareRoundB", sans-serif;
}

.heroTitle {
  margin: 0 0 26px;
  font-size: 2.2rem;
  line-height: 1.3;
  color: #111827;
  font-family: "Paperlogy8", "NanumSquareRoundEB", sans-serif;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.heroDesc {
  margin: 0 auto 40px;
  font-size: 1rem;
  line-height: 1.85;
  color: #4b5563;
  max-width: 560px;
}

.heroCtas {
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-wrap: wrap;
}

.cta {
  padding: 12px 22px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 700;
  font-family: "NanumSquareRoundEB", sans-serif;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease,
    background-color 0.15s ease, color 0.15s ease;
  border: 1px solid transparent;
  line-height: 1.2;
}

.cta:hover {
  transform: translateY(-1px);
}

.ctaPrimary {
  background: #66bdff;
  color: #fff;
  box-shadow: 0 6px 18px rgba(102, 189, 255, 0.35);
}

.ctaPrimary:hover {
  background: #4faae9;
  box-shadow: 0 8px 22px rgba(102, 189, 255, 0.45);
}

.ctaGhost {
  background: #ffffff;
  color: #2563eb;
  border-color: #cfe4ff;
}

.ctaGhost:hover {
  background: #f5f9ff;
  border-color: #9ecbff;
}

.heroDecor {
  position: absolute;
  width: 320px;
  height: 320px;
  right: -80px;
  top: -80px;
  background: radial-gradient(closest-side, rgba(102, 189, 255, 0.25), rgba(102, 189, 255, 0));
  border-radius: 50%;
  pointer-events: none;
}

/* ================================================
   섹션 공통
   ================================================ */
.section {
  max-width: 880px;
  margin: 0 auto;
  padding: 120px 24px 48px;
}

.eyebrow {
  margin: 0 0 16px;
  font-size: 12px;
  font-weight: 700;
  color: #66bdff;
  letter-spacing: 0.14em;
  font-family: var(--font-poppins), "NanumSquareRoundEB", sans-serif;
}

.eyebrowAlt {
  margin: 0 0 14px;
  font-size: 11px;
  font-weight: 700;
  color: #8b6bb8;
  letter-spacing: 0.16em;
  font-family: var(--font-poppins), "NanumSquareRoundEB", sans-serif;
}

.sectionTitle {
  margin: 0 0 28px;
  font-size: 1.7rem;
  color: #111827;
  font-family: "Paperlogy7", "NanumSquareRoundEB", sans-serif;
  font-weight: 700;
  letter-spacing: -0.01em;
  line-height: 1.35;
}

.sectionLead {
  margin: 0 0 56px;
  font-size: 1rem;
  line-height: 1.85;
  color: #4b5563;
}

.sectionLeadShort {
  margin: 0 0 52px;
  font-size: 0.95rem;
  line-height: 1.75;
  color: #6b7280;
}

/* ================================================
   ABOUT 섹션 — 플랫폼 홈 목업 (실제 링꾹라이브 홈 화면 미니어처)
   ================================================ */
.aboutIntroLead {
  margin-bottom: 36px;
}

.aboutPlatformMock {
  border: 1px solid #e6ecf5;
  border-radius: 16px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 16px 48px -20px rgba(15, 23, 42, 0.18),
    0 6px 18px -8px rgba(15, 23, 42, 0.08);
  margin-bottom: 16px;
}

/* ---- 브라우저 툴바 ---- */
.aboutMockToolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: #f1f5f9;
  border-bottom: 1px solid #e2e8f0;
}

.aboutMockDots {
  display: flex;
  gap: 5px;
  flex-shrink: 0;
}

.aboutMockDots span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #cbd5e1;
}

.aboutMockDots span:first-child {
  background: #fb7185;
}

.aboutMockDots span:nth-child(2) {
  background: #fbbf24;
}

.aboutMockDots span:nth-child(3) {
  background: #34d399;
}

.aboutMockUrlBar {
  flex: 1;
  min-width: 0;
  display: flex;
  justify-content: center;
}

.aboutMockUrl {
  display: inline-block;
  padding: 4px 14px;
  font-size: 10.5px;
  color: #64748b;
  font-family: var(--font-poppins), "NanumSquareRoundB", sans-serif;
  font-weight: 600;
  letter-spacing: 0.02em;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  white-space: nowrap;
}

.aboutMockToolbarSpacer {
  width: 40px;
  flex-shrink: 0;
}

.aboutMockBody {
  padding: 0 0 16px;
  background: #ffffff;
}

/* ---- 헤더 (로고 + 로그인) ---- */
.aboutMockHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px 8px;
}

.aboutMockLogoText {
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.12em;
  background: linear-gradient(90deg, #66bdff, #b48aff);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: var(--font-poppins), "NanumSquareRoundEB", sans-serif;
}

.aboutMockLoginBtn {
  padding: 4px 10px;
  font-size: 9.5px;
  font-weight: 700;
  color: #475569;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  font-family: "NanumSquareRoundB", sans-serif;
}

/* ---- 네비 (라이브/아티스트/동영상/커뮤니티) ---- */
.aboutMockNav {
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 6px 18px 8px;
  border-bottom: 1px solid #eef2f7;
}

.aboutMockNavItem {
  font-size: 10.5px;
  color: #94a3b8;
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: 700;
  padding-bottom: 4px;
  position: relative;
}

.aboutMockNavActive {
  color: #1d4ed8;
}

.aboutMockNavActive::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -8px;
  height: 2px;
  background: linear-gradient(90deg, #66bdff, #66bdff);
  border-radius: 2px;
}

/* ---- 전광판 마키 ---- */
.aboutMockMarquee {
  position: relative;
  overflow: hidden;
  background: linear-gradient(90deg, rgba(102, 189, 255, 0.08), rgba(180, 138, 255, 0.08));
  border-bottom: 1px solid #eef2f7;
  padding: 7px 0;
  mask-image: linear-gradient(90deg, transparent, #000 6%, #000 94%, transparent);
  -webkit-mask-image: linear-gradient(90deg, transparent, #000 6%, #000 94%, transparent);
}

.aboutMockMarqueeTrack {
  display: flex;
  gap: 28px;
  white-space: nowrap;
  font-size: 10px;
  color: #475569;
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: 700;
  animation: aboutMarqueeMove 22s linear infinite;
}

.aboutMockMarqueeTrack span {
  flex-shrink: 0;
}

.aboutMockMarqueePaused {
  animation: none;
}

@keyframes aboutMarqueeMove {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .aboutMockMarqueeTrack {
    animation: none;
  }
}

/* ---- 타입 필터 ---- */
.aboutMockTypeFilter {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 14px 18px 10px;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-x: contain;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.aboutMockTypeFilter::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

.aboutMockHeartBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  font-size: 14px;
  color: #94a3b8;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 50%;
  line-height: 1;
}

.aboutMockTypeBtn {
  flex-shrink: 0;
  padding: 4px 11px;
  font-size: 10px;
  color: #64748b;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: 700;
}

.aboutMockTypeActive {
  color: #ffffff;
  background: linear-gradient(90deg, #66bdff, #66bdff);
  border-color: transparent;
}

/* ---- 검색 + 정렬 ---- */
.aboutMockSearchRow {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 18px 12px;
}

.aboutMockSearch {
  flex: 1;
  min-width: 0;
  padding: 3px 14px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
}

.aboutMockSearchPh {
  font-size: 10.5px;
  color: #9ca3af;
  font-family: "NanumSquareRoundB", sans-serif;
}

.aboutMockSortBtn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  font-size: 10px;
  color: #475569;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: 700;
  white-space: nowrap;
}

.aboutMockSortArrow {
  font-size: 9px;
  opacity: 0.6;
}

/* ---- 타일 그리드 (포스터 + 메타) ---- */
.aboutMockTiles {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px 14px;
  padding: 4px 18px 4px;
}

.aboutMockTile {
  min-width: 0;
}

.aboutMockPoster {
  position: relative;
  width: 100%;
  aspect-ratio: 5 / 7;
  border-radius: 10px;
  overflow: hidden;
  background: #e5e7eb;
}

.aboutMockPosterArt {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
}

.aboutMockPosterImg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.aboutMockPosterSkeleton {
  background: linear-gradient(90deg, #e8ecf1 0%, #dfe4ea 45%, #e8ecf1 90%);
  background-size: 200% 100%;
  animation: aboutMockPosterSkeletonShimmer 1.4s ease-in-out infinite;
}

@keyframes aboutMockPosterSkeletonShimmer {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: -100% 0;
  }
}

/* 링꾹예매중 라벨 (왼쪽 상단) */
.aboutMockLinkookLabel {
  display: none;
  position: absolute;
  top: 4px;
  left: 5px;
  z-index: 3;
  padding: 2px 6px;
  font-size: 8.5px;
  font-weight: 800;
  color: #ffffff;
  background: linear-gradient(45deg, #66bdff, #ff69b4);
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(102, 189, 255, 0.4);
  font-family: "NanumSquareRoundEB", sans-serif;
  letter-spacing: 0.02em;
  line-height: 1.3;
  animation: aboutLinkookPulse 2s ease-in-out infinite;
}

@keyframes aboutLinkookPulse {

  0%,
  100% {
    box-shadow: 0 2px 6px rgba(102, 189, 255, 0.4);
  }

  50% {
    box-shadow: 0 3px 10px rgba(255, 105, 180, 0.55);
  }
}

/* D-day 라벨 (오른쪽 상단) */
.aboutMockDday {
  display: none;
  position: absolute;
  top: 4px;
  right: 5px;
  z-index: 3;
  padding: 2px 6px;
  font-size: 9px;
  font-weight: 800;
  color: #111827;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.18);
  font-family: var(--font-poppins), "NanumSquareRoundEB", sans-serif;
  line-height: 1.3;
}

.aboutMockDdayHot {
  color: #ffffff;
  background: linear-gradient(45deg, #007bff, #0056b3);
  box-shadow: 0 2px 6px rgba(0, 123, 255, 0.4);
  animation: aboutDdayPulse 1.5s ease-in-out infinite;
}

@keyframes aboutDdayPulse {

  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.06);
  }
}

.aboutMockDdayEnded {
  display: none;
  position: absolute;
  top: 4px;
  right: 5px;
  z-index: 3;
  padding: 2px 6px;
  font-size: 8.5px;
  font-weight: 800;
  color: #8d8d8d;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.12);
  font-family: var(--font-noto-b), "NanumSquareRoundEB", sans-serif;
  line-height: 1.3;
}

/* 타입 아이콘 (왼쪽 하단 동그라미) — 홈 타일과 동일한 PNG */
.aboutMockTypeIconImg {
  position: absolute;
  bottom: 5px;
  left: 5px;
  z-index: 2;
  width: 22px;
  height: 22px;
  padding: 3px;
  box-sizing: border-box;
  object-fit: contain;
  background: #ffffff;
  border-radius: 50%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
}

.aboutMockTypeIconFallback {
  position: absolute;
  bottom: 5px;
  left: 5px;
  z-index: 2;
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  background: #ffffff;
  border-radius: 50%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
}

/* 좋아요 (오른쪽 하단) */
.aboutMockHeart {
  position: absolute;
  bottom: 5px;
  right: 5px;
  z-index: 2;
  width: 22px;
  height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid #e5e7eb;
  border-radius: 50%;
  line-height: 1;
}

.aboutMockTileDate {
  margin-top: 6px;
  font-size: 9.5px;
  color: #777777;
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: 700;
}

.aboutMockTileTitle {
  margin-top: 2px;
  font-size: 11.5px;
  font-weight: 800;
  color: #333333;
  font-family: "NanumSquareRoundEB", sans-serif;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.aboutMockLineup {
  margin-top: 5px;
  display: flex;
  gap: 4px;
  overflow: hidden;
}

.aboutMockLineupPill {
  display: inline-block;
  padding: 1px 6px;
  font-size: 9px;
  color: #333333;
  background: #f2f2f2;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  font-family: "NanumSquareRoundR", sans-serif;
  white-space: nowrap;
  flex-shrink: 0;
  line-height: 13px;
}

.aboutMockLineupMuted {
  color: #94a3b8;
  background: #f8fafc;
  border-color: #e2e8f0;
}

.aboutMockSkeletonLine {
  height: 10px;
  border-radius: 4px;
  background: linear-gradient(90deg, #eef2f7 0%, #e2e8f0 50%, #eef2f7 100%);
  background-size: 200% 100%;
  animation: aboutMockPosterSkeletonShimmer 1.4s ease-in-out infinite;
  margin-top: 8px;
}

.aboutMockSkeletonDate {
  width: 42%;
  margin-top: 6px;
}

.aboutMockSkeletonTitle {
  width: 88%;
  height: 12px;
  margin-top: 6px;
}

.aboutMockSkeletonLineup {
  display: flex;
  gap: 4px;
  margin-top: 8px;
}

.aboutMockSkeletonPill {
  width: 36px;
  height: 16px;
  border-radius: 10px;
  background: #eef2f7;
}

.aboutMockTilesEmpty {
  grid-column: 1 / -1;
  padding: 8px 4px 12px;
}

.aboutMockTilesEmptyText {
  margin: 0;
  font-size: 10px;
  color: #64748b;
  line-height: 1.55;
  font-family: "NanumSquareRoundB", sans-serif;
  text-align: center;
}

@media (prefers-reduced-motion: reduce) {

  .aboutMockPosterSkeleton,
  .aboutMockSkeletonLine {
    animation: none;
  }

  .aboutMockLinkookLabel,
  .aboutMockDdayHot {
    animation: none;
  }
}

.aboutKeyPoints {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.aboutKeyPoint {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: #ffffff;
  border: 1px solid #eef2f7;
  border-radius: 12px;
}

.aboutKeyPointEmoji {
  font-size: 16px;
  line-height: 1;
}

.aboutKeyPointText {
  font-size: 0.82rem;
  color: #475569;
  line-height: 1.55;
  font-family: "NanumSquareRoundB", sans-serif;
}

.aboutKeyPointText b {
  color: #1d4ed8;
  font-family: "NanumSquareRoundEB", sans-serif;
  font-weight: 800;
}


/* ================================================
   듀얼 네비
   ================================================ */
.dualNav {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.dualNavItem {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 30px 26px;
  background: #ffffff;
  border: 1px solid #eef2f7;
  border-radius: 16px;
  color: #111827;
  text-decoration: none;
  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;
}

.dualNavItem:hover {
  transform: translateY(-2px);
  border-color: rgba(102, 189, 255, 0.5);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.07);
}

.dualNavLabel {
  font-size: 11px;
  letter-spacing: 0.14em;
  color: #66bdff;
  font-family: "NanumSquareRoundEB", sans-serif;
  font-weight: 700;
}

.dualNavTitle {
  font-size: 1.05rem;
  color: #111827;
  font-family: "NanumSquareRoundEB", sans-serif;
  font-weight: 800;
}

.dualNavSub {
  font-size: 0.85rem;
  color: #6b7280;
  line-height: 1.5;
}

/* ================================================
   주최자 솔루션 섹션
   ================================================ */
.organizerSection {
  background: linear-gradient(180deg, #fbfaff 0%, #f5f6fc 100%);
  margin-top: 64px;
  padding-bottom: 96px;
}

.organizerSection .section {
  padding-top: 96px;
  padding-bottom: 16px;
}

.pillarGrid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 8px;
}

.pillarCard {
  background: #ffffff;
  border: 1px solid #ece9f7;
  border-radius: 18px;
  padding: 30px 26px;
  position: relative;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.pillarCard:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 30px rgba(60, 50, 120, 0.08);
}

.pillarTag {
  display: inline-block;
  padding: 4px 10px;
  margin-bottom: 18px;
  font-size: 10px;
  letter-spacing: 0.14em;
  color: #6b53b8;
  background: rgba(139, 107, 184, 0.12);
  border-radius: 999px;
  font-family: var(--font-poppins), "NanumSquareRoundEB", sans-serif;
  font-weight: 700;
}

.pillarTitle {
  margin: 0 0 12px;
  font-size: 1.1rem;
  color: #111827;
  font-family: "NanumSquareRoundEB", sans-serif;
  font-weight: 800;
  letter-spacing: -0.01em;
}

.pillarLine {
  margin: 0 0 22px;
  font-size: 0.9rem;
  color: #4b5563;
  line-height: 1.65;
}

.pillarChips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.pillarChip {
  display: inline-block;
  padding: 5px 11px;
  font-size: 11px;
  font-weight: 700;
  color: #6b53b8;
  background: rgba(139, 107, 184, 0.08);
  border: 1px solid rgba(139, 107, 184, 0.18);
  border-radius: 999px;
  font-family: "NanumSquareRoundB", sans-serif;
}

.subNote {
  display: inline-block;
  margin-left: 6px;
  color: #9ca3af;
  font-size: 0.8rem;
}

/* ================================================
   예매관리 시스템 - 대시보드 목업 + 피처 행
   ================================================ */
.dashboardSplit {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);
  gap: 44px;
  align-items: center;
}

/* 알림톡 섹션: 리스트 왼쪽 · 목업 오른쪽 (데스크톱) */
.dashboardSplitMockRight {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.1fr);
}

.dashboardSplitMockRight> :first-child {
  order: 2;
}

.dashboardSplitMockRight> :last-child {
  order: 1;
}

/* 미니 대시보드 목업 */
.dashboardMock {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
  font-family: var(--font-nanum-r), sans-serif;
  user-select: none;
}

.mockToolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: #f7f8fb;
  border-bottom: 1px solid #eef0f4;
}

.mockDots {
  display: flex;
  gap: 5px;
}

.mockDots span {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #e1e3e9;
}

.mockDots span:first-child {
  background: #ff6058;
}

.mockDots span:nth-child(2) {
  background: #ffbe2f;
}

.mockDots span:nth-child(3) {
  background: #29c842;
}

.mockTitle {
  font-size: 11px;
  color: #6b7280;
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: 700;
}

.mockTabs {
  display: flex;
  gap: 6px;
  padding: 14px 14px 10px;
  flex-wrap: wrap;
}

.mockTab {
  padding: 5px 10px;
  font-size: 11px;
  border-radius: 8px;
  background: #f3f4f6;
  color: #6b7280;
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: 700;
}

.mockTabActive {
  background: rgba(102, 189, 255, 0.14);
  color: #2a8be0;
  border: 1px solid rgba(102, 189, 255, 0.3);
  padding: 4px 9px;
}

.mockSearch {
  margin: 6px 14px 12px;
  padding: 8px 12px;
  background: #f7f8fb;
  border: 1px solid #eef0f4;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.mockSearchIcon {
  font-size: 12px;
  filter: grayscale(0.4);
}

.mockSearchText {
  font-size: 11px;
  color: #9ca3af;
}

.mockTable {
  display: flex;
  flex-direction: column;
}

.mockRow {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-top: 1px solid #f1f3f7;
  font-size: 11px;
  transition: background-color 0.45s ease;
}

.mockRowHighlight {
  background: linear-gradient(90deg, rgba(102, 189, 255, 0.07) 0%, rgba(255, 255, 255, 0) 100%);
}

.mockRowDemoPulse {
  animation: mockRowDemoPulse 0.55s ease-out;
}

@keyframes mockRowDemoPulse {
  0% {
    background-color: transparent;
  }

  40% {
    background-color: rgba(42, 139, 224, 0.14);
  }

  100% {
    background-color: transparent;
  }
}

@media (prefers-reduced-motion: reduce) {
  .mockRowDemoPulse {
    animation: none;
  }

  .mockRow {
    transition-duration: 0.01ms;
  }

  .mockStatus {
    transition-duration: 0.01ms;
  }
}

.mockTid {
  color: #2a8be0;
  font-weight: 700;
  font-family: var(--font-poppins), sans-serif;
  font-size: 10.5px;
  letter-spacing: 0.02em;
}

.mockName {
  color: #374151;
  font-weight: 700;
  font-family: "NanumSquareRoundB", sans-serif;
}

.mockTime {
  color: #9ca3af;
  font-family: var(--font-poppins), sans-serif;
  font-size: 10.5px;
  margin-left: auto;
}

.mockExtra {
  padding: 2px 7px;
  border-radius: 999px;
  background: #fff7ed;
  color: #c2410c;
  font-size: 10px;
  font-weight: 700;
}

.mockStatus {
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 10.5px;
  font-weight: 700;
  font-family: "NanumSquareRoundB", sans-serif;
  transition: background-color 0.4s ease, color 0.4s ease, transform 0.35s ease;
}

.mockStatusWait {
  background: #fff5db;
  color: #b06b00;
}

.mockStatusOk {
  background: #e2f5e9;
  color: #1f8a3a;
}

.mockStatusCancel {
  background: #fee2e2;
  color: #b91c1c;
}

.mockStatusRefund {
  background: #ede9fe;
  color: #5b21b6;
}

.mockStatusEntered {
  background: #e0f2fe;
  color: #0369a1;
}

/* 액션 칩 */
.mockActions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 14px 4px;
  border-top: 1px dashed #eef0f4;
  margin-bottom: 10px;
}

.mockActionChip {
  padding: 5px 10px;
  font-size: 10.5px;
  border-radius: 8px;
  background: #f7f8fb;
  color: #4b5563;
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: 700;
  border: 1px solid #eef0f4;
  line-height: 15px;
}

/* 집계 카드 */
.mockSummary {
  margin: 10px 14px 12px;
  padding: 12px 14px;
  background: linear-gradient(135deg, #fafbff 0%, #fff 100%);
  border: 1px solid #eef0f7;
  border-radius: 10px;
}

.mockSummaryRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.mockSummaryLabel {
  font-size: 11px;
  color: #6b7280;
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: 700;
}

.mockSummaryValue {
  font-size: 13.5px;
  color: #111827;
  font-family: "Paperlogy7", "NanumSquareRoundEB", sans-serif;
  font-weight: 800;
  letter-spacing: -0.01em;
}

.mockSummaryRowSub {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px dashed #eef0f7;
}

.mockSummaryLabelSub {
  font-size: 10px;
  color: #9ca3af;
}

.mockSummaryValueSub {
  font-size: 11.5px;
  color: #2a8be0;
  font-family: var(--font-poppins), sans-serif;
  font-weight: 700;
  letter-spacing: 0.02em;
}

/* ================================================
   카카오 알림톡 · QR 티켓 페이지 (예매관리와 동일 dashboardSplit)
   ================================================ */
.qrDemoCardBody {
  width: 100%;
  min-width: 0;
  padding: 14px 14px 20px;
  box-sizing: border-box;
}

/* 알림톡 ↔ QR 페이지 토글 스테이지 (같은 영역에 겹쳐서 전환) */
.alimtalkQrStage {
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  min-width: 0;
}

/* 데모용 가상 커서: 그리드 1칸에 겹쳐 알림톡·QR 위에 표시 */
.alimtalkDemoCursor {
  grid-column: 1;
  grid-row: 1;
  justify-self: start;
  align-self: start;
  z-index: 50;
  width: 32px;
  height: 32px;
  pointer-events: none;
  filter: drop-shadow(0 1px 1.5px rgba(15, 23, 42, 0.18)) drop-shadow(0 2px 6px rgba(15, 23, 42, 0.08));
  transition: none;
  will-change: transform;
}

.alimtalkDemoCursorMove {
  transition: transform 1.08s cubic-bezier(0.22, 0.95, 0.28, 1);
}

.alimtalkDemoCursorSvg {
  display: block;
  overflow: visible;
  transform-origin: 4px 2px;
  transition: transform 0.1s cubic-bezier(0.33, 1, 0.68, 1);
  shape-rendering: geometricPrecision;
}

.alimtalkDemoCursorPath {
  fill: #ffffff;
  stroke: #1e293b;
  stroke-width: 1.6;
  stroke-linejoin: round;
  stroke-linecap: round;
  paint-order: stroke fill;
}

.alimtalkDemoCursorPress .alimtalkDemoCursorSvg {
  transform: scale(0.88);
}

.kakaoMockBubbleBtnDemoPress {
  transform: scale(0.97);
  background: #e4e4e4 !important;
}

.stageScreen {
  grid-column: 1;
  grid-row: 1;
  transition: opacity 0.42s ease, transform 0.42s ease, filter 0.42s ease;
  will-change: opacity, transform;
}

/* 기본 상태: 알림톡 보임, QR 페이지 숨김 */
.stageScreenQr {
  opacity: 0;
  transform: translateY(18px) scale(0.985);
  pointer-events: none;
  filter: blur(2px);
}

/* QR 활성 상태: 알림톡 숨김, QR 페이지 보임 */
.stageQrActive .kakaoMock {
  opacity: 0;
  transform: translateY(-14px) scale(0.985);
  pointer-events: none;
  filter: blur(2px);
}

.stageQrActive .stageScreenQr {
  opacity: 1;
  transform: none;
  pointer-events: auto;
  filter: none;
}

/* ===== 카카오 알림톡 메시지 목업 ===== */
.kakaoMock {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background: #b2c7d9;
  border-radius: 14px;
  padding: 16px 26px 18px 14px;
  font-family: var(--font-nanum-r), "Apple SD Gothic Neo", sans-serif;
  user-select: none;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.08);
}

/* 수신 말풍선처럼 왼쪽에 붙이고 오른쪽에 여백 */
.kakaoMockThread {
  align-self: flex-start;
  width: 100%;
  max-width: min(300px, 72%);
  min-width: 0;
}

.kakaoMockHead {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.kakaoMockSender {
  font-size: 13px;
  color: #1f2937;
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: 700;
}

.kakaoMockKakaoBadge {
  margin-left: auto;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #4a4a4a;
  color: #ffffff;
  font-size: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-poppins), sans-serif;
  font-weight: 700;
  letter-spacing: -0.03em;
}

.kakaoMockBubble {
  background: #ffffff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.kakaoMockBubbleHead {
  background: #fae100;
  padding: 12px 16px 11px;
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: 700;
  font-size: 13.5px;
  color: #1f2937;
}

.kakaoMockBubbleBody {
  padding: 14px 16px 10px;
  font-size: 12.5px;
  color: #1f2937;
  line-height: 1.62;
}

.kakaoMockBubbleBody p {
  margin: 0 0 11px;
}

.kakaoMockBubbleBody p:last-child {
  margin-bottom: 0;
}

.kakaoMockBubbleBody b {
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: 700;
}

/* 알림톡 하단 버튼: 카톡 스크린샷처럼 연회색 둥근 블록 + 좌우 여백 + 행 간격 */
.kakaoMockBubbleActions {
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 2px 12px 14px;
  background: #ffffff;
}

.kakaoMockBubbleBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: 12px 10px 11px;
  background: #f2f2f2;
  border: 0;
  border-radius: 10px;
  text-align: center;
  font-size: 14px;
  line-height: 1.35;
  letter-spacing: -0.02em;
  color: #191919;
  font-family: -apple-system, BlinkMacSystemFont, "Apple SD Gothic Neo", "Malgun Gothic",
    "Nanum Gothic", sans-serif;
  font-weight: 400;
  appearance: none;
  -webkit-appearance: none;
}

/* 클릭 가능한 첫 행만 살짝 눌림 피드백 */
button.kakaoMockBubbleBtn {
  cursor: pointer;
  transition: background-color 0.15s ease, transform 0.12s ease;
}

button.kakaoMockBubbleBtn:hover,
button.kakaoMockBubbleBtn:focus-visible {
  background: #e9e9e9;
  outline: none;
}

button.kakaoMockBubbleBtn:active {
  background: #e0e0e0;
  transform: scale(0.992);
}

/* QR 페이지 상단의 "← 알림톡" 뒤로가기 버튼 */
.mockBackBtn {
  margin-left: auto;
  padding: 4px 10px;
  font-size: 10.5px;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  background: #ffffff;
  color: #475569;
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.18s ease, color 0.18s ease,
    border-color 0.18s ease, transform 0.18s ease;
  appearance: none;
  -webkit-appearance: none;
}

.mockBackBtn:hover,
.mockBackBtn:focus-visible {
  background: #f1f5f9;
  border-color: #cbd5e1;
  color: #0f172a;
  outline: none;
}

.mockBackBtn:active {
  transform: translateY(1px);
}

.mockBackBtnDemoPress {
  transform: scale(0.97);
  background: #f1f5f9 !important;
  border-color: #cbd5e1 !important;
}

.kakaoMockTime {
  margin: 8px 2px 0 0;
  text-align: right;
  font-size: 10.5px;
  color: #6b7280;
}

/* 모션 감소 선호 시 전환 효과 단순화 */
@media (prefers-reduced-motion: reduce) {
  .stageScreen {
    transition: opacity 0.2s linear;
  }

  .stageScreenQr,
  .stageQrActive .kakaoMock {
    transform: none;
    filter: none;
  }

  .formBuilderDemoCursorMove,
  .alimtalkDemoCursorMove {
    transition: none;
  }
}

.qrDemoHint {
  margin: 0 0 14px;
  font-size: 0.82rem;
  color: #6b7280;
  line-height: 1.55;
}

.qrPathCode {
  display: inline-block;
  margin: 0 2px;
  padding: 2px 7px;
  font-size: 0.82em;
  font-family: var(--font-poppins), Menlo, Consolas, monospace;
  color: #334155;
  background: #f1f5f9;
  border-radius: 6px;
  vertical-align: baseline;
}

.qrMockCard {
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 20px;
  padding: 28px 24px 24px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);
  border: 1px solid #e2e8f0;
  text-align: center;
  box-sizing: border-box;
}

.qrMockHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.qrMockBrand {
  font-family: "NanumSquareRoundB", sans-serif;
  font-size: 13px;
  letter-spacing: 0.06em;
  color: #6d28d9;
}

.qrMockBadge {
  font-size: 11px;
  padding: 4px 10px;
  background: linear-gradient(135deg, rgba(124, 58, 237, 0.12), rgba(91, 33, 182, 0.12));
  color: #6d28d9;
  border: 1px solid rgba(124, 58, 237, 0.3);
  border-radius: 999px;
  font-family: "NanumSquareRoundB", sans-serif;
}

.qrMockTitle {
  margin: 0 0 6px;
  font-size: 22px;
  line-height: 1.3;
  color: #0f172a;
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: 700;
  word-break: keep-all;
}

.qrMockSubtitle {
  margin: 0 0 22px;
  font-size: 14px;
  color: #475569;
  line-height: 1.5;
}

.qrMockDot {
  margin: 0 6px;
  color: #cbd5e1;
}

.qrMockImageWrap {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: #ffffff;
  border: 1px dashed #cbd5e1;
  border-radius: 16px;
  margin-bottom: 22px;
}

.qrMockImage {
  width: 260px;
  max-width: 100%;
  height: auto;
  display: block;
}

.qrMockImagePlaceholder {
  width: 260px;
  max-width: 100%;
  aspect-ratio: 1 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-size: 13px;
  font-family: var(--font-nanum-r), sans-serif;
}

.qrMockInfo {
  text-align: left;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px 16px;
  margin-bottom: 18px;
}

.qrMockInfoRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #e2e8f0;
}

.qrMockInfoRow:last-child {
  border-bottom: none;
}

.qrMockInfoLabel {
  font-size: 13px;
  color: #64748b;
  font-family: var(--font-nanum-r), sans-serif;
}

.qrMockInfoValue {
  font-size: 14px;
  color: #0f172a;
  font-family: "NanumSquareRoundB", sans-serif;
  text-align: right;
  word-break: break-all;
}

.qrMockInfoMono {
  font-family: Menlo, Consolas, "NanumSquareRoundB", monospace;
  letter-spacing: 0.04em;
}

.qrMockStatus {
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 999px;
  font-family: "NanumSquareRoundB", sans-serif;
}

.qrMockStatusOk {
  background: rgba(16, 185, 129, 0.12);
  color: #047857;
  border: 1px solid rgba(16, 185, 129, 0.3);
}

.qrMockFooterNote {
  margin: 0;
  font-size: 12px;
  color: #94a3b8;
  line-height: 1.55;
  font-family: var(--font-nanum-r), sans-serif;
}

/* ================================================
   권한관리 (LiveDetail → 관리 메뉴 → 권한관리)
   ================================================ */
.permissionStage {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 14px;
  min-width: 0;
  margin: 0 auto;
}

/* 진입 경로 안내: 공연 상세 › ⚙ 관리 메뉴 › 권한관리 */
.permissionEntryPath {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px 14px;
  background: #f8fafc;
  border: 1px dashed #e2e8f0;
  border-radius: 999px;
  font-size: 12px;
  color: #64748b;
  font-family: "NanumSquareRoundB", sans-serif;
  width: fit-content;
  max-width: 100%;
}

.permissionEntryStep {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.permissionEntryStepActive {
  padding: 3px 10px;
  background: linear-gradient(135deg, rgba(124, 58, 237, 0.12), rgba(91, 33, 182, 0.12));
  color: #6d28d9;
  border-radius: 999px;
  border: 1px solid rgba(124, 58, 237, 0.3);
}

.permissionEntryGear {
  width: 14px;
  height: 14px;
  color: #475569;
  flex-shrink: 0;
}

.permissionEntryArrow {
  color: #cbd5e1;
  font-size: 14px;
  font-family: var(--font-poppins), sans-serif;
}

/* 권한관리 모달 카드 */
.permissionMock {
  width: 100%;
  max-width: 460px;
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.1);
  overflow: hidden;
  font-family: var(--font-nanum-r), sans-serif;
  user-select: none;
  box-sizing: border-box;
}

.permissionMockHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  border-bottom: 1px solid #eef0f4;
  background: #ffffff;
}

.permissionMockHeaderTitle {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  font-family: "NanumSquareRoundB", sans-serif;
}

.permissionMockHeaderClose {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-size: 22px;
  line-height: 1;
}

.permissionMockBody {
  padding: 18px;
}

.permissionMockHint {
  margin: 0 0 16px;
  padding: 10px 12px;
  background: #f8fafc;
  border-radius: 8px;
  font-size: 12.5px;
  color: #475569;
  line-height: 1.55;
}

.permissionMockHint b {
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: 700;
  color: #0f172a;
}

.permissionMockSectionTitle {
  margin: 0 0 10px;
  font-size: 13px;
  font-weight: 700;
  color: #1f2937;
  font-family: "NanumSquareRoundB", sans-serif;
}

.permissionMockSectionTitle:not(:first-child) {
  margin-top: 18px;
}

.permissionMockMemberList {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.permissionMockMember {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: #f8f9fa;
  border-radius: 8px;
}

.permissionMockAvatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  font-family: "NanumSquareRoundB", sans-serif;
  flex-shrink: 0;
}

.permissionMockAvatarPurple {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.permissionMockAvatarPink {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.permissionMockMemberInfo {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.permissionMockMemberName {
  font-size: 13px;
  font-weight: 700;
  color: #1f2937;
  font-family: "NanumSquareRoundB", sans-serif;
}

.permissionMockMemberEmail {
  font-size: 11.5px;
  color: #6b7280;
  word-break: break-all;
}

.permissionMockOwnerBadge {
  flex-shrink: 0;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 700;
  border-radius: 999px;
  background: rgba(124, 58, 237, 0.1);
  color: #6d28d9;
  border: 1px solid rgba(124, 58, 237, 0.25);
  font-family: "NanumSquareRoundB", sans-serif;
}

.permissionMockRemoveBtn {
  flex-shrink: 0;
  padding: 5px 12px;
  font-size: 11.5px;
  font-weight: 700;
  background: #f44336;
  color: #ffffff;
  border-radius: 6px;
  font-family: "NanumSquareRoundB", sans-serif;
}

.permissionMockSearchRow {
  display: flex;
  align-items: stretch;
  gap: 8px;
}

.permissionMockSearch {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  background: #ffffff;
  border: 1px solid #ddd;
  border-radius: 8px;
}

.permissionMockSearchIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

.permissionMockSearchIcon svg {
  width: 14px;
  height: 14px;
  display: block;
}

.permissionMockSearchText {
  font-size: 12.5px;
  color: #9ca3af;
  font-family: var(--font-nanum-r), sans-serif;
}

.permissionMockAddBtn {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 18px;
  font-size: 13px;
  font-weight: 700;
  background: #2196f3;
  color: #ffffff;
  border-radius: 8px;
  font-family: "NanumSquareRoundB", sans-serif;
}

/* ================================================
   QR 입장 확인 (CheckInView) 섹션
   입장 결과는 브라우저 내장 TTS(Web Speech API) 안내 포함
   ================================================ */
.checkinStage {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 0;
  min-width: 0;
}

.checkinPhone {
  position: relative;
  width: 100%;
  max-width: 300px;
  background: #0a0a0a;
  border-radius: 36px;
  border: 10px solid #1f2937;
  overflow: hidden;
  box-shadow:
    0 28px 64px rgba(15, 23, 42, 0.28),
    0 0 0 1px rgba(15, 23, 42, 0.06);
  display: flex;
  flex-direction: column;
  user-select: none;
  font-family: "NanumSquareRoundB", sans-serif;
  color: #fff;
}

.checkinPhoneNotch {
  position: absolute;
  top: 6px;
  left: 50%;
  transform: translateX(-50%);
  width: 70px;
  height: 14px;
  background: #1f2937;
  border-radius: 999px;
  z-index: 5;
}

/* ── 폰 내부 헤더 ─────────────────────── */
.checkinMockHeader {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 22px 12px 10px;
  background: #111;
  border-bottom: 1px solid #222;
}

.checkinMockBack {
  color: #fff;
  font-size: 16px;
  flex-shrink: 0;
  line-height: 1;
}

.checkinMockHeaderCenter {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  overflow: hidden;
}

.checkinMockHeaderTitle {
  font-size: 12.5px;
  font-weight: 700;
  color: #ffffff;
  font-family: "NanumSquareRoundB", sans-serif;
}

.checkinMockHeaderSubtitle {
  font-size: 10.5px;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: var(--font-nanum-r), sans-serif;
}

.checkinMockStatsBadge {
  flex-shrink: 0;
  padding: 3px 8px;
  border-radius: 999px;
  background: rgba(102, 189, 255, 0.15);
  color: #66bdff;
  font-size: 10px;
  font-weight: 700;
  border: 1px solid rgba(102, 189, 255, 0.3);
  font-family: "NanumSquareRoundB", sans-serif;
}

/* ── 카메라 / QR 스캔 영역 ──────────────── */
.checkinMockCamera {
  position: relative;
  height: 210px;
  background:
    radial-gradient(circle at 30% 25%, rgba(102, 189, 255, 0.08), transparent 60%),
    radial-gradient(circle at 75% 80%, rgba(124, 58, 237, 0.08), transparent 60%),
    #050505;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.checkinMockScanFrame {
  position: relative;
  width: 140px;
  height: 140px;
  border-radius: 14px;
  box-shadow: 0 0 0 2000px rgba(0, 0, 0, 0.5);
}

.checkinMockScanCorner {
  position: absolute;
  width: 22px;
  height: 22px;
  border: 3px solid #66bdff;
}

.checkinMockScanCornerTL {
  top: -2px;
  left: -2px;
  border-right: none;
  border-bottom: none;
  border-top-left-radius: 6px;
}

.checkinMockScanCornerTR {
  top: -2px;
  right: -2px;
  border-left: none;
  border-bottom: none;
  border-top-right-radius: 6px;
}

.checkinMockScanCornerBL {
  bottom: -2px;
  left: -2px;
  border-right: none;
  border-top: none;
  border-bottom-left-radius: 6px;
}

.checkinMockScanCornerBR {
  bottom: -2px;
  right: -2px;
  border-left: none;
  border-top: none;
  border-bottom-right-radius: 6px;
}

.checkinMockScanLine {
  position: absolute;
  left: 10px;
  right: 10px;
  top: 50%;
  height: 2px;
  background: linear-gradient(90deg, transparent, #66bdff 50%, transparent);
  box-shadow: 0 0 12px rgba(102, 189, 255, 0.7);
  animation: checkinMockScanAnim 1.8s ease-in-out infinite;
  pointer-events: none;
}

@keyframes checkinMockScanAnim {
  0% {
    transform: translateY(-58px);
    opacity: 0.7;
  }

  50% {
    opacity: 1;
  }

  100% {
    transform: translateY(58px);
    opacity: 0.7;
  }
}

/* QR 그래픽 — 단순화한 4×4 셀로 QR 느낌만 표현 */
.checkinMockQr {
  position: absolute;
  inset: 22px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(4, 1fr);
  gap: 6px;
  opacity: 0.35;
}

.checkinMockQr span {
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.6);
}

.checkinMockQr span:nth-child(1),
.checkinMockQr span:nth-child(4),
.checkinMockQr span:nth-child(6),
.checkinMockQr span:nth-child(11),
.checkinMockQr span:nth-child(13),
.checkinMockQr span:nth-child(16) {
  background: transparent;
}

.checkinMockScanHint {
  position: absolute;
  bottom: 12px;
  left: 0;
  right: 0;
  margin: 0;
  text-align: center;
  font-size: 10.5px;
  color: rgba(255, 255, 255, 0.7);
  font-family: var(--font-nanum-r), sans-serif;
}

/* ── 결과 패널 (입장 가능) ─────────────── */
.checkinMockResult {
  padding: 14px 14px 16px;
  background: #0d2a0d;
  border-top: 2px solid #2e7d32;
}

.checkinMockResultStatusRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.checkinMockResultStatusBadge {
  display: inline-block;
  padding: 4px 11px;
  background: rgba(46, 125, 50, 0.28);
  color: #7df3a0;
  border-radius: 999px;
  font-size: 10.5px;
  font-weight: 700;
  border: 1px solid rgba(46, 125, 50, 0.55);
  font-family: "NanumSquareRoundB", sans-serif;
}

.checkinMockResultClose {
  color: #94a3b8;
  font-size: 13px;
  line-height: 1;
}

.checkinMockResultInfo {
  margin-bottom: 12px;
}

.checkinMockResultNameRow {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 4px;
}

.checkinMockResultName {
  font-size: 15px;
  font-weight: 700;
  color: #ffffff;
  font-family: "NanumSquareRoundB", sans-serif;
}

.checkinMockResultTicketNo {
  font-size: 11px;
  color: #94a3b8;
  font-family: var(--font-poppins), sans-serif;
}

.checkinMockResultQty {
  font-size: 12px;
  color: #cbd5e1;
  font-family: var(--font-nanum-r), sans-serif;
}

.checkinMockResultBtn {
  width: 100%;
  padding: 10px;
  background: #2e7d32;
  color: #ffffff;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  font-family: "NanumSquareRoundB", sans-serif;
  box-shadow: 0 6px 14px rgba(46, 125, 50, 0.35);
}

/* ================================================
   예매 폼 빌더 (TicketForm) 섹션
   ================================================ */
.formBuilderSplit {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.1fr);
  gap: 44px;
  align-items: center;
}

.formBuilderMockStage {
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  min-width: 0;
}

.formBuilderDemoCursor {
  grid-column: 1;
  grid-row: 1;
  justify-self: start;
  align-self: start;
  z-index: 30;
  width: 32px;
  height: 32px;
  pointer-events: none;
  filter: drop-shadow(0 1px 1.5px rgba(15, 23, 42, 0.18)) drop-shadow(0 2px 6px rgba(15, 23, 42, 0.08));
  transition: none;
  will-change: transform;
}

.formBuilderDemoCursorMove {
  transition: transform 1.16s cubic-bezier(0.22, 0.95, 0.28, 1);
}

.formBuilderDemoCursorSvg {
  display: block;
  overflow: visible;
  transform-origin: 4px 2px;
  transition: transform 0.1s cubic-bezier(0.33, 1, 0.68, 1);
  shape-rendering: geometricPrecision;
}

.formBuilderDemoCursorPath {
  fill: #ffffff;
  stroke: #1e293b;
  stroke-width: 1.6;
  stroke-linejoin: round;
  stroke-linecap: round;
  paint-order: stroke fill;
}

.formBuilderDemoCursorPress .formBuilderDemoCursorSvg {
  transform: scale(0.88);
}

.formMock {
  grid-column: 1;
  grid-row: 1;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
  font-family: var(--font-nanum-r), sans-serif;
  user-select: none;
}

.formMockBody {
  padding: 14px 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.formMockSection {
  background: #fbfcfe;
  border: 1px solid #eef2f7;
  border-radius: 10px;
  padding: 12px 14px;
}

.formMockHead {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.formMockHeadTitle {
  font-size: 12px;
  color: #111827;
  font-family: "NanumSquareRoundEB", sans-serif;
  font-weight: 800;
}

.formMockBadge {
  font-size: 10px;
  padding: 2px 7px;
  border-radius: 999px;
  background: rgba(102, 189, 255, 0.14);
  color: #2a8be0;
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: 700;
}

.formMockInfoBox {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.formMockInfoRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 11px;
}

.formMockInfoLabel {
  color: #6b7280;
}

.formMockInfoValue {
  color: #111827;
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: 700;
}

.formMockLabelRow {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}

.formMockLabel {
  font-size: 11.5px;
  color: #374151;
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: 700;
}

.formMockRequired {
  font-size: 9.5px;
  padding: 1.5px 6px;
  border-radius: 999px;
  background: #fff1f2;
  color: #be123c;
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: 700;
}

.formMockRadioGroup {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.formMockRadio {
  padding: 6px 12px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  font-size: 11px;
  color: #4b5563;
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: 700;
}

.formMockRadioActive {
  background: rgba(102, 189, 255, 0.12);
  color: #2a8be0;
  border-color: rgba(102, 189, 255, 0.45);
}

.formMockPackage {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px 12px;
  background: #ffffff;
  margin-bottom: 8px;
}

.formMockPackage:last-of-type {
  margin-bottom: 0;
}

.formMockPackageSelected {
  border-color: rgba(102, 189, 255, 0.55);
  box-shadow: 0 0 0 3px rgba(102, 189, 255, 0.12);
  background: linear-gradient(135deg, #f7fbff 0%, #ffffff 100%);
}

.formMockPackageClickable {
  cursor: pointer;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.12s ease;
}

.formMockPackageClickable:hover {
  border-color: rgba(102, 189, 255, 0.35);
}

.formMockPackageDemoPress {
  transform: scale(0.985);
}

.formMockPackageCheckSpacer {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.formMockPackageRow {
  display: flex;
  align-items: center;
  gap: 6px;
}

.formMockPackageCheck {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #66bdff;
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
}

.formMockPackageName {
  font-size: 11.5px;
  color: #111827;
  font-family: var(--font-poppins), sans-serif;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.formMockPackagePrice {
  margin-left: auto;
  font-size: 11.5px;
  color: #111827;
  font-family: "NanumSquareRoundEB", sans-serif;
  font-weight: 800;
}

.formMockPackageDesc {
  margin-top: 5px;
  margin-left: 22px;
  font-size: 10.5px;
  color: #6b7280;
  line-height: 1.55;
}

.formMockAddonList {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.formMockPurchase {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px 12px;
}

.formMockPurchaseRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.formMockPurchaseName {
  font-size: 11.5px;
  color: #111827;
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: 700;
}

.formMockPurchasePrice {
  font-size: 11.5px;
  color: #374151;
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: 700;
}

.formMockQtyRow {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.formMockQtyBtn {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  background: #f3f4f6;
  color: #374151;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
}

button.formMockQtyBtn {
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  font-family: inherit;
  line-height: 1;
  transition: background-color 0.15s ease, transform 0.12s ease;
}

button.formMockQtyBtn:hover {
  background: #e5e7eb;
}

.formMockQtyBtnDemoPress {
  transform: scale(0.9);
  background: #e5e7eb !important;
}

.formMockQtyValue {
  min-width: 18px;
  text-align: center;
  font-size: 11.5px;
  font-family: var(--font-poppins), sans-serif;
  font-weight: 700;
  color: #111827;
}

.formMockQtySubtotal {
  margin-left: auto;
  font-size: 11px;
  color: #2a8be0;
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: 700;
}

.formMockTotal {
  margin-top: 4px;
  padding: 14px 16px;
  background: linear-gradient(135deg, rgba(102, 189, 255, 0.08) 0%, rgba(180, 138, 255, 0.06) 100%);
  border: 1px solid rgba(102, 189, 255, 0.25);
  border-radius: 10px;
  text-align: center;
}

.formMockTotalLabel {
  font-size: 10.5px;
  color: #6b7280;
  font-family: "NanumSquareRoundB", sans-serif;
  font-weight: 700;
  margin-bottom: 4px;
}

.formMockTotalValue {
  font-size: 1.2rem;
  color: #2a8be0;
  font-family: "Paperlogy8", "NanumSquareRoundEB", sans-serif;
  font-weight: 800;
  letter-spacing: -0.01em;
  transition: color 0.28s ease, transform 0.28s ease;
}

.formMockTotalBumpAnim {
  animation: formMockTotalBumpKey 0.48s ease;
}

@keyframes formMockTotalBumpKey {
  0% {
    transform: scale(1);
    color: #2a8be0;
  }

  35% {
    transform: scale(1.07);
    color: #1d4ed8;
  }

  100% {
    transform: scale(1);
    color: #2a8be0;
  }
}

.formMockTotalCalc {
  margin-top: 4px;
  font-size: 10px;
  color: #9ca3af;
  font-family: var(--font-poppins), sans-serif;
  letter-spacing: 0.02em;
}

/* 피처 행 */
.featureRows {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 36px;
}

.featureRow {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.featureRowNum {
  flex-shrink: 0;
  font-size: 1.4rem;
  color: #66bdff;
  font-family: var(--font-poppins), sans-serif;
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1;
  margin-top: 2px;
}

.featureRowTitle {
  margin: 0 0 10px;
  font-size: 1rem;
  color: #111827;
  font-family: "NanumSquareRoundEB", sans-serif;
  font-weight: 800;
  letter-spacing: -0.01em;
}

.featureRowDesc {
  margin: 0;
  font-size: 0.88rem;
  color: #4b5563;
  line-height: 1.8;
}

/* ================================================
   부가 서비스 - 인라인 컴팩트
   ================================================ */
.addonRow {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.addonItem {
  background: linear-gradient(135deg, #ffffff 0%, #faf8ff 100%);
  border: 1px dashed #d4cbe9;
  border-radius: 12px;
  padding: 20px 22px;
}

.addonItemTitle {
  margin: 0 0 6px;
  font-size: 0.98rem;
  color: #111827;
  font-family: "NanumSquareRoundEB", sans-serif;
  font-weight: 800;
}

.addonItemDesc {
  margin: 0;
  font-size: 0.85rem;
  color: #6b7280;
  line-height: 1.55;
}

/* ================================================
   함께한 공연 - 가로 마퀴 (왼쪽 → 오른쪽 흐름)
   ================================================ */
.referenceMarqueeWrap {
  width: 100%;
  overflow: hidden;
  container-type: inline-size;
  container-name: reference-marquee;
}

.referenceMarquee {
  width: 100%;
}

.referenceTrack {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: max-content;
  gap: 12px;
  animation: referenceMarqueeX 52s linear infinite reverse;
}

.referenceTrack:hover {
  animation-play-state: paused;
}

/* 한 줄에 약 4건 (컨테이너 너비 기준, 카드 사이 간격 3칸) */
.referenceTrack .referenceCard {
  flex: 0 0 auto;
  width: 178px;
}

@supports (width: 1cqi) {
  .referenceTrack .referenceCard {
    flex: 0 0 calc((100cqi - 36px) / 4);
    width: calc((100cqi - 36px) / 4);
    max-width: 200px;
  }
}

@keyframes referenceMarqueeX {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .referenceTrack {
    animation: none;
  }
}

.referenceCard {
  background: #ffffff;
  border: 1px solid #eef2f7;
  border-radius: 14px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  display: flex;
  flex-direction: column;
}

.referenceCard:hover {
  transform: translateY(-3px);
  border-color: rgba(102, 189, 255, 0.45);
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.1);
}

.referenceCard:focus {
  outline: none;
}

.referenceCard:focus-visible {
  outline: 2px solid #66bdff;
  outline-offset: 3px;
}

.referenceImgWrap {
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 4;
  background: linear-gradient(135deg, #e9edf7 0%, #f3ecff 100%);
  overflow: hidden;
}

.referenceImg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.4s ease;
}

.referenceCard:hover .referenceImg {
  transform: scale(1.04);
}

.referenceImgPlaceholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  font-weight: 800;
  color: rgba(107, 83, 184, 0.45);
  font-family: var(--font-poppins), "NanumSquareRoundEB", sans-serif;
}

.referenceBadge {
  position: absolute;
  top: 8px;
  left: 8px;
  padding: 3px 8px;
  font-size: 9.5px;
  font-weight: 700;
  color: #ffffff;
  background: rgba(17, 24, 39, 0.72);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  border-radius: 999px;
  font-family: "NanumSquareRoundB", sans-serif;
  letter-spacing: 0.02em;
}

/* 스켈레톤 */
.referenceSkeleton {
  cursor: default;
  pointer-events: none;
}

.referenceSkeleton:hover {
  transform: none;
  border-color: #eef2f7;
  box-shadow: none;
}

.referenceSkeleton .referenceImgWrap {
  background: linear-gradient(90deg,
      #eef0f5 0%,
      #f5f6fa 50%,
      #eef0f5 100%);
  background-size: 200% 100%;
  animation: refShimmer 1.4s infinite ease-in-out;
}

@keyframes refShimmer {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: -100% 0;
  }
}

/* 운영자 CTA */
.organizerCta {
  margin-top: 56px;
  padding: 32px 32px;
  background: #ffffff;
  border: 1px solid #ece9f7;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
  box-shadow: 0 8px 20px rgba(60, 50, 120, 0.05);
}

.organizerCtaTitle {
  margin: 0 0 8px;
  font-size: 1.05rem;
  color: #111827;
  font-family: "NanumSquareRoundEB", sans-serif;
  font-weight: 800;
}

.organizerCtaDesc {
  margin: 0;
  font-size: 0.88rem;
  color: #6b7280;
  line-height: 1.7;
}

/* ================================================
   FAQ
   ================================================ */
.faqList {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.faqItem {
  background: #ffffff;
  border: 1px solid #eef2f7;
  border-radius: 12px;
  padding: 8px 8px;
  transition: border-color 0.15s ease;
}

.faqItem[open] {
  border-color: rgba(102, 189, 255, 0.45);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);
}

.faqQ {
  list-style: none;
  cursor: pointer;
  padding: 18px 20px;
  font-size: 0.95rem;
  font-weight: 700;
  color: #111827;
  font-family: "NanumSquareRoundB", sans-serif;
  position: relative;
  padding-right: 64px;
}

.faqQ::-webkit-details-marker {
  display: none;
}

.faqQ::after {
  content: "+";
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  color: #66bdff;
  font-size: 1.4rem;
  font-weight: 700;
  transition: transform 0.2s ease;
}

.faqItem[open] .faqQ::after {
  content: "−";
}

.faqA {
  margin: 0;
  padding: 4px 20px 22px;
  font-size: 0.9rem;
  color: #4b5563;
  line-height: 1.85;
}

/* ================================================
   하단 CTA
   ================================================ */
.ctaSection {
  max-width: 880px;
  margin: 80px auto 0;
  padding: 72px 24px;
  text-align: center;
  background: linear-gradient(135deg, #66bdff 0%, #8aa8ff 60%, #b48aff 100%);
  border-radius: 0;
  color: #ffffff;
}

.ctaTitle {
  margin: 0 0 18px;
  font-size: 1.6rem;
  color: #ffffff;
  font-family: "Paperlogy8", "NanumSquareRoundEB", sans-serif;
  font-weight: 800;
  letter-spacing: -0.01em;
  line-height: 1.4;
}

.ctaDesc {
  margin: 0 0 36px;
  font-size: 0.95rem;
  line-height: 1.85;
  color: rgba(255, 255, 255, 0.92);
}

.ctaButtons {
  display: flex;
  gap: 10px;
  justify-content: center;
  flex-wrap: wrap;
}

.ctaSection .ctaPrimary {
  background: #ffffff;
  color: #2563eb;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

.ctaSection .ctaPrimary:hover {
  background: #f6faff;
}

.ctaSection .ctaGhost {
  background: transparent;
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.6);
}

.ctaSection .ctaGhost:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: #ffffff;
}

/* ================================================
   회사 정보 박스
   ================================================ */
.companyBox {
  max-width: 880px;
  margin: 0 auto;
  padding: 64px 24px 48px;
}

.companyTitle {
  margin: 0 0 20px;
  font-size: 0.95rem;
  color: #374151;
  font-family: "NanumSquareRoundEB", sans-serif;
  font-weight: 800;
}

.companyList {
  list-style: none;
  padding: 0;
  margin: 0 0 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 0.82rem;
  line-height: 1.65;
}

.companyList li {
  display: grid;
  grid-template-columns: minmax(7.5rem, max-content) minmax(0, 1fr);
  column-gap: 14px;
  row-gap: 2px;
  align-items: start;
}

.companyListLabel {
  font-weight: 700;
  color: #374151;
  font-family: "NanumSquareRoundB", sans-serif;
}

.companyListValue {
  margin: 0;
  color: #6b7280;
  min-width: 0;
  word-break: keep-all;
  overflow-wrap: break-word;
}

.companyNotice {
  margin: 12px 0 0;
  font-size: 0.78rem;
  color: #9ca3af;
  line-height: 1.6;
}

/* ================================================
   반응형 — 모바일
   ================================================ */
@media screen and (max-width: 768px) {
  .hero {
    padding-left: max(28px, env(safe-area-inset-left, 0px));
    padding-right: max(28px, env(safe-area-inset-right, 0px));
  }

  .section {
    padding-left: max(28px, env(safe-area-inset-left, 0px));
    padding-right: max(28px, env(safe-area-inset-right, 0px));
  }

  .ctaSection {
    padding-left: max(28px, env(safe-area-inset-left, 0px));
    padding-right: max(28px, env(safe-area-inset-right, 0px));
  }

  .companyBox {
    padding-left: max(28px, env(safe-area-inset-left, 0px));
    padding-right: max(28px, env(safe-area-inset-right, 0px));
  }

  .dualNav {
    grid-template-columns: 1fr;
  }

  .pillarGrid,
  .addonRow {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .dashboardSplit {
    grid-template-columns: 1fr;
    gap: 36px;
  }

  /* 목업을 항상 위에 (알림톡: 데스크톱용 order 초기화) */
  .dashboardSplitMockRight> :first-child {
    order: -1;
  }

  .dashboardSplitMockRight> :last-child {
    order: 0;
  }

  .formBuilderSplit {
    grid-template-columns: 1fr;
    gap: 36px;
  }

  .formBuilderSplit .formBuilderMockStage {
    order: -1;
  }

  .featureRows {
    gap: 28px;
  }

  .aboutMockTiles {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  /* 모바일·태블릿: 목업은 2건만 노출 */
  .aboutMockTiles>.aboutMockTile:nth-child(3) {
    display: none;
  }

  .aboutMockNav {
    gap: 16px;
  }

  .aboutKeyPoints {
    grid-template-columns: 1fr;
  }
}

@media screen and (max-width: 480px) {
  .hero {
    padding-top: 64px;
    padding-bottom: 72px;
    padding-left: max(30px, env(safe-area-inset-left, 0px));
    padding-right: max(30px, env(safe-area-inset-right, 0px));
  }

  .heroLogo {
    width: 170px;
    margin-bottom: 24px;
  }

  .heroTitle {
    font-size: 1.65rem;
  }

  .heroDesc {
    font-size: 0.9rem;
    margin-bottom: 32px;
  }

  .heroCtas .cta {
    flex: 1;
    min-width: 0;
  }

  .section {
    padding-top: 88px;
    padding-bottom: 32px;
    padding-left: max(30px, env(safe-area-inset-left, 0px));
    padding-right: max(30px, env(safe-area-inset-right, 0px));
  }

  .sectionTitle {
    font-size: 1.35rem;
    margin-bottom: 22px;
  }

  .sectionLead {
    font-size: 0.9rem;
    margin-bottom: 40px;
  }

  .sectionLeadShort {
    font-size: 0.88rem;
    margin-bottom: 36px;
  }

  .aboutIntroLead {
    margin-bottom: 28px;
  }

  .aboutMockHeader,
  .aboutMockNav,
  .aboutMockTypeFilter,
  .aboutMockSearchRow,
  .aboutMockTiles {
    padding-left: 14px;
    padding-right: 14px;
  }

  .aboutMockTiles {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px 12px;
  }

  .aboutMockNav {
    gap: 4px;
  }

  .aboutMockTypeFilter {
    gap: 5px;
  }

  .kakaoMockThread {
    max-width: 100%;
  }

  .dualNav {
    grid-template-columns: 1fr;
  }

  .dualNavItem {
    padding: 26px 22px;
  }

  .pillarGrid,
  .addonRow {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .referenceTrack {
    animation-duration: 44s;
  }

  .pillarCard {
    padding: 26px 24px;
  }

  .addonItem {
    padding: 22px 24px;
  }

  .pillarTitle {
    font-size: 1.02rem;
  }

  .organizerSection {
    margin-top: 72px;
    padding-bottom: 32px;
  }

  .organizerSection .section {
    padding-top: 88px;
  }

  .dashboardSplit {
    grid-template-columns: 1fr;
    gap: 32px;
  }

  .formBuilderSplit {
    grid-template-columns: 1fr;
    gap: 32px;
  }

  .formBuilderSplit .formBuilderMockStage {
    order: -1;
  }

  .featureRows {
    gap: 24px;
  }

  .featureRowNum {
    font-size: 1.2rem;
  }

  .mockTabs {
    padding: 12px 12px 8px;
  }

  .mockTab,
  .mockTabActive {
    font-size: 10.5px;
  }

  .faqQ {
    font-size: 0.9rem;
    padding: 16px 20px;
    padding-right: 64px;
  }

  .faqA {
    font-size: 0.85rem;
    padding: 4px 20px 18px;
  }

  .organizerCta {
    padding: 26px 24px;
    align-items: stretch;
    text-align: left;
  }

  .organizerCta .cta {
    width: 100%;
  }

  .ctaSection {
    margin-top: 56px;
    padding-top: 56px;
    padding-bottom: 56px;
    padding-left: max(30px, env(safe-area-inset-left, 0px));
    padding-right: max(30px, env(safe-area-inset-right, 0px));
  }

  .ctaTitle {
    font-size: 1.3rem;
  }

  .ctaDesc {
    font-size: 0.88rem;
  }

  .ctaButtons .cta {
    flex: 1;
    min-width: 0;
  }

  .companyBox {
    padding-top: 48px;
    padding-bottom: 36px;
    padding-left: max(30px, env(safe-area-inset-left, 0px));
    padding-right: max(30px, env(safe-area-inset-right, 0px));
  }

  .companyList {
    font-size: 0.78rem;
    gap: 8px;
  }

  .companyList li {
    grid-template-columns: minmax(7rem, max-content) minmax(0, 1fr);
    column-gap: 10px;
  }

  .qrMockCard {
    padding: 22px 18px 20px;
    border-radius: 18px;
  }

  .qrMockTitle {
    font-size: 1.15rem;
  }

  .qrMockSubtitle {
    font-size: 13px;
    margin-bottom: 18px;
  }

  .permissionEntryPath {
    padding: 8px 12px;
    font-size: 11px;
    gap: 6px;
    border-radius: 12px;
    width: 100%;
    box-sizing: border-box;
  }

  .permissionMockBody {
    padding: 14px;
  }

  .permissionMockMember {
    padding: 9px 10px;
    gap: 8px;
  }

  .permissionMockAvatar {
    width: 28px;
    height: 28px;
    font-size: 12.5px;
  }

  .permissionMockMemberEmail {
    font-size: 11px;
  }
}
</style>
